import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Button, Col, Row, Form, Card, Container } from 'react-bootstrap';
import { MdAdd, MdClose, MdChevronRight, MdChevronLeft } from "react-icons/md";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import Swal from 'sweetalert2';
import { ToastContainer, toast, Zoom } from 'react-toastify';
import { motion, AnimatePresence } from 'framer-motion';
import { storage } from "../../firebase"; // Import your secondary storage
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

import Header from '../topbotm/Header';
import Footer from '../topbotm/Footer';
import Sidebar from '../dashboard/sidebar';
import api from '../../api';
import { AddClient } from '../client/addcllient';
import { CopyMsg } from '../others/copy_msg';
import { MSGS } from '../others/msg';
import { Dimcontext } from "../../context/pagecontext";
import { AuthContext } from '../../context/authContext';
import { Datacontext } from "../../context/dataContext";

import { Stack, Typography, Switch } from '@mui/material';
import { styled } from '@mui/material/styles';

import "react-toastify/dist/ReactToastify.css";
import '../css/others/Doc_Reg.css';
//import { signInAnonymously } from 'firebase/auth';

const ThreeStateToggle = ({ value, onChange, disabled }) => {
  // Logic for the sliding thumb
  const getTranslate = () => {
    if (value === 'yes') return 'translateX(38px)'; // Right (Purple)
    if (value === 'no') return 'translateX(2px)';   // Left (Yellow)
    return 'translateX(20px)';                      // Center (Neutral)
  };

  // Background Color Logic
  const getBgColor = () => {
    if (value === 'yes') return '#ece917'; // Theme Yellow
    if (value === 'no') return '#8a2be2';  // Theme Purple
    return '#d1d1d1';                      // Neutral Grey
  };

  // Icon Color Logic (High Contrast)
  const getIconColor = (type) => {
    if (value === null) return '#555'; // Visible grey when neutral
    
    if (type === 'no') {
      // If 'No' is selected, background is Purple (#8a2be2), so icon should be Yellow
      return value === 'no' ? '#ece917' : 'rgba(0, 0, 0, 0.2)';
    }
    
    if (type === 'yes') {
      // If 'Yes' is selected, background is Yellow (#ece917), so icon should be Purple
      return value === 'yes' ? '#4a127e' : '#ece917';
    }
  };


  const handleClick = (e) => {
    if (disabled) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    // Decision logic based on new smaller width (66px)
    if (x < 22) onChange('no');
    else if (x > 44) onChange('yes');
    else onChange(null);
  };

  return (
    <div
      onClick={handleClick}
      style={{
        position: 'relative', 
        width: '66px', 
        height: '26px',
        backgroundColor: getBgColor(), 
        borderRadius: '13px',
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        padding: '0 8px', 
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1, 
        transition: 'all 0.3s ease',
        boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.2)',
        border: '1px solid rgba(0,0,0,0.1)'
      }}
    >
      {/* Icons flipped: X on left, Check on right */}
      <span style={{ color: getIconColor('no'), fontWeight: 'bold', zIndex: 1, fontSize: '12px', transition: 'color 0.3s' }}>✕</span>
      <span style={{ color: getIconColor('yes'), fontWeight: 'bold', zIndex: 1, fontSize: '12px', transition: 'color 0.3s' }}>✓</span>
      
      {/* Sliding Thumb */}
      <div style={{
        position: 'absolute', 
        top: '2px', 
        left: '0',
        width: '20px', 
        height: '20px', 
        backgroundColor: '#fff',
        borderRadius: '50%', 
        transition: 'transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)',
        transform: getTranslate(), 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
      }}>
        <div style={{ 
          width: '4px', 
          height: '4px', 
          backgroundColor: getBgColor(), 
          borderRadius: '50%',
          transition: 'background-color 0.3s' 
        }} />
      </div>
    </div>
  );
};

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28, height: 16, padding: 0, display: 'flex',
  '&:active': { '& .MuiSwitch-thumb': { width: 15 }, '& .MuiSwitch-switchBase.Mui-checked': { transform: 'translateX(9px)' } },
  '& .MuiSwitch-switchBase': { padding: 2, '&.Mui-checked': { transform: 'translateX(12px)', color: '#fff', '& + .MuiSwitch-track': { opacity: 1, backgroundColor: '#e7ac2d' } } },
  '& .MuiSwitch-thumb': { boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)', width: 12, height: 12, borderRadius: 6, transition: theme.transitions.create(['width'], { duration: 200 }) },
  '& .MuiSwitch-track': { borderRadius: 16 / 2, opacity: 1, backgroundColor: 'rgba(0,0,0,.25)', boxSizing: 'border-box' },
}));

const Registration = () => {
  const { user } = useContext(AuthContext);
  const { users, clients, docs, fetchDocs, fetchcountdoc, fetchClients, fetchDocuments, doc_Count, sVillage, sOffice, sZone, sLayout, fetchSLayout, ecs } = useContext(Datacontext);
  const { setDim } = useContext(Dimcontext);

  // --- STEPPER STATE ---
  const [currentStep, setCurrentStep] = useState(1);
  const [bt, setBt] = useState(false);

  // --- FORM STATES ---
  const [date, set_Date] = useState("");
  const [app_No, set_App_No] = useState('');
  const [options_doc, set_options_doc] = useState([]);
  const [options, set_options] = useState([]);
  const [option_User, set_options_User] = useState([]);
  
  const [ref1, set_ref] = useState(null);
  const [vill, set_vill] = useState(null);
  const [layout, set_Layout] = useState(null);
  const [off, set_off] = useState(null);
  const [zone, set_zone] = useState(null);
  const [doc, set_doc] = useState(null);
  const [users1, set_users] = useState([]);
  
  const [add, setAdd] = useState(false);
  const [msg, set_msg] = useState(false);
  const [activeMsgText, setActiveMsgText] = useState("");
  const [status, setStatus] = useState("offline");

  const [formData, setFormData] = useState({ zoneId: '', officeId: '', villageId: '', layoutId: '' });

  // Complex Dynamic Sections
  const [buyer_Details, set_Buyer_Details] = useState([{ buyer_Detail: {}, buyer_aadhar: "" }]);
  const [seller_Details, set_Seller_Details] = useState([{ seller_Detail: {}, seller_aadhar: "" }]);
  const [witness_Details, set_Witness_Details] = useState([{ witness_Detail: {}, witness_aadhar: "" }, { witness_Detail: {}, witness_aadhar: "" }]);
  const [parent_document, set_Parent_Document] = useState([{ type: "", number: "" }]);
  const [stamp_Paper, set_Stamp_Paper] = useState([{ value: "", number: "" }]);
  const [hasStampPaper, setHasStampPaper] = useState("yes");
  const [alreadyAppliedEc, setAlreadyAppliedEc] = useState("no");
  const [linkedEc, setLinkedEc] = useState(null);

  const [individual, set_Individual] = useState({
  approximate_quatation: "",
  sfno: "", 
  siteno: "", 
  document_Split: "NO", 
  payment_Info: "", 
  document_date: "",
  remarks: "",           // Added for final remarks
  internal_notes: ""     // Added for private notes
});

  const [edit, set_Edit] = useState({
    // Added file and fileData to Draft
    draft_send: { clicked: 0, values: null, through: '', file: null, fileData: null },
    
    value_check: { clicked: 0, values: null, doc_value: "" },
    draft_prepared: { clicked: 0, values: null },
    draft_approved: { clicked: 0, values: null, by: "" },
    certificate_applied: { clicked: 0, values: null, eca_no: "" },
    
    // Added file and fileData to Certificate
    certificate_received: { clicked: 0, values: null, file: null, fileData: null },
    
    deed_no: { clicked: 0, values: null, tp_no: '' },
    
    // Added file and fileData to Token
    token_initiated: { clicked: 0, values: null, token_no: "", time: "", file: null, fileData: null },
    
    // Added file and fileData to Registered Document
    document_registered: { clicked: 0, values: null, document_no: "", file: null, fileData: null },
    
    document_pending: { clicked: 0, values: "no", document_no: "" },
    document_collected: { clicked: 0, values: null },
    
    // Added file and fileData to Scanned Document
    document_scanned: { clicked: 0, values: null, file: null, fileData: null },
    
    payment: { clicked: 0, values: null },
    other: { clicked: 0, values: null, cusDetail: null },
});

  // Logic: Role-based field locking
// Prevents standard users from altering data once it has been saved/clicked
const canToggle = (fieldKey) => {
  const fieldData = edit[fieldKey];
  if (!fieldData) return true;

  // Rule: If role is "user" and the field has already been processed (clicked >= 1)
  if (fieldKey === "document_pending"){
    if (user?.role === "user" && fieldData.clicked >= 2) {
      return false;
    }
  } else{
    if (user?.role === "user" && fieldData.clicked >= 1) {
      return false;
    }
  }
  return true;
};

  // --- HELPERS ---
  const showToast = (msg) => toast.warn(msg, { position: "bottom-center", theme: "dark", transition: Zoom });
  const TitleCase = (str) => str ? str.toLowerCase().replace(/\s+/g, ' ').split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') : "";

  // --- DATA FETCHING ---
  const get_document = useCallback(() => {
    if (docs) {
      const sortedOptions = [...docs].sort((a, b) => (a.doc_Name || "").localeCompare(b.doc_Name || "")).map(v => ({ value: v.doc_Name, label: v.doc_Name?.toUpperCase() }));
      set_options_doc(sortedOptions);
    }
  }, [docs]);

  const get_customer = useCallback(() => {
    if (clients) set_options(clients.map(v => ({ value: v, label: `${v.name?.toUpperCase()} - ${v.nick_name || ""} - ${v.mobile}` })));
  }, [clients]);

  const get_User = useCallback(() => {
    if (users) {
      set_options_User(users.map(u => ({ value: u.name, label: u.name?.toUpperCase() })));
      set_users([{ value: user.name, label: user.name?.toUpperCase() }]);
    }
  }, [users, user]);

  const defaultn = useCallback(() => {
    const today = new Date();
    const d = String(today.getDate()).padStart(2, "0");
    const m = String(today.getMonth() + 1).padStart(2, "0");
    const countNum = String(doc_Count?.data?.number || 0).padStart(3, "0");
    set_App_No(`TD/RD/${today.getFullYear()}/${countNum}`);
    set_Date(`${d}-${m}-${today.getFullYear()}`);
  }, [doc_Count]);

  useEffect(() => { get_User(); get_document(); get_customer(); defaultn(); }, [get_User, get_document, get_customer, defaultn]);

  const option_through = [
    { value: "offline", label: "OFFLINE" },
    { value: "online", label: "ONLINE" }
  ]

  const handleMsg = (type, data) => {
    setActiveMsgText(MSGS[type](data));
    set_msg(true);
    setDim(true);
  };
  
  const validateMandatory = () => {
    // --- 1. Base Application Details ---
    if (!formData.zoneId || !formData.officeId || !users1 || users1.length === 0 || !users1.every(user => !!user)) {
        showToast("Application Details (Zone, Office, Managed By) are mandatory!");
        return false;
    }
    if (!individual.document_date) { 
        showToast("Please select a Document Date."); 
        return false; 
    }
    if (!doc) { 
        showToast("Please select a Register Document."); 
        return false; 
    }

    // --- 3. Conditional Edit Fields (Steps 4 - 9) ---

    // Step 4: Offline Draft (only when Presenceless = Offline)
    if (status !== 'online') {
      if (edit?.draft_send?.values === "yes") {
          if (!edit.draft_send.through?.trim()) { 
              showToast("Please specify how the draft was sent (through)."); 
              return false; 
          }
          // CREATION MODE: Check for Draft File ONLY if 'online'
          if (edit.draft_send.through === "online" && !edit.draft_send.file) {
              showToast("Please upload the Draft PDF.");
              return false;
          }
      }
      
      if (edit?.draft_approved?.values === "yes" && !edit.draft_approved.by?.trim()) { 
          showToast("Please specify who approved the draft (by)."); 
          return false; 
      }
    }

    // Step 5: EC Process
    if (alreadyAppliedEc === "yes") {
        if (!linkedEc?.ec?.id) {
            showToast("Please select an already applied EC from the list.");
            return false;
        }
        if (edit?.certificate_received?.values === "yes" && !edit.certificate_received.file) {
            showToast("Please upload the Received Certificate PDF.");
            return false;
        }
    } else {
        if (edit?.certificate_applied?.values === "yes" && !edit.certificate_applied.eca_no?.trim()) { 
            showToast("Please enter the ECA No."); 
            return false; 
        }
        // CREATION MODE: Check for Certificate File
        if (edit?.certificate_received?.values === "yes" && !edit.certificate_received.file) {
            showToast("Please upload the Received Certificate PDF.");
            return false;
        }
    }

    // Step 6: Online Draft / Token
    if (edit?.deed_no?.values === "yes" && !edit.deed_no.tp_no?.trim()) { 
        showToast("Please enter the TP No."); 
        return false; 
    }

    // Token Initiated only required when Presenceless = Offline
    if (status !== 'online' && edit?.token_initiated?.values === "yes") {
        if (!edit.token_initiated.token_no?.trim() || !edit.token_initiated.time) { 
            showToast("Please provide both Token No and Time."); 
            return false; 
        }
        // CREATION MODE: Check for Token Document File
        if (!edit.token_initiated.file) {
            showToast("Please upload the Token Document PDF.");
            return false;
        }
    }

    // Step 7: Registration Process
    if (status !== 'online' && edit?.document_pending?.values === "yes" && !edit.document_pending.document_no?.trim()) { 
        showToast("Please provide the Pending Document No."); 
        return false; 
    }

    if (edit?.document_registered?.values === "yes") {
        if (!edit.document_registered.document_no?.trim()) { 
            showToast("Please provide the Registered Document No."); 
            return false; 
        }
    }

    // Step 8: Return Collection
    // CREATION MODE: Check for Scanned Document File
    if (edit?.document_scanned?.values === "yes" && !edit.document_scanned.file) {
        showToast("Please upload the Scanned Document PDF.");
        return false;
    }

    // Step 9: Application Completed
    if (edit?.other?.values === "yes" && (!edit.other.cusDetail || !edit.other.cusDetail.name)) { 
        showToast("Please select the Recipient from the dropdown."); 
        return false; 
    }

    return true; // Everything is filled out correctly!
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    if(!validateMandatory()) return;

    // 2. Extract basic native form data
    const formDataObj = new FormData(e.target);
    const data = Object.fromEntries(formDataObj.entries());

    // ----------------------------------------------------------------
    // 3. MANDATORY FIELD VALIDATION (Before API & Before Confirmation)
    // ----------------------------------------------------------------
    
    // Using the 'individual' state object mapped in your JSX Steps
    if (individual.siteno && !/^[A-Za-z0-9/\-,.\s ]+$/.test(individual.siteno)) {
      return showToast("Text field invalid!..Only Numbers, Text, / , - . in Site No ...");
    }
    if (individual.sfno && !/^[A-Za-z0-9/\-,.\s ]+$/.test(individual.sfno)) {
      return showToast("Text field invalid!..Only Numbers, Text, / , - . in SF No ...");
    }

    if (individual.approximate_quatation && !/^[0-9]+$/.test(individual.approximate_quatation)) {
      return showToast("Text field invalid!..Only Numbers in Approximate Quotation...");
    }

    // Checking dynamic Parent Document Array
    for (let i = 0; i < parent_document.length; i++) {
      const doc = parent_document[i];
      if (doc.number && !/^[A-Za-z0-9 /|-]+$/.test(doc.number)) {
        return showToast(`Parent Document Row ${i + 1}: Only alphanumeric and / | - allowed`);
      }
    }

    // Checking dynamic Stamp Paper Array (only when stamp paper is required)
    if (hasStampPaper === "yes") {
      for (let i = 0; i < stamp_Paper.length; i++) {
        const doc = stamp_Paper[i];
        if (doc.value && !/^[0-9 ]+$/.test(doc.value)) {
          return showToast(`Stamp Paper Row ${i + 1}: Only numbers allowed in Value`);
        }
        if (doc.number && !/^[A-Za-z0-9\s\-/]+$/.test(doc.number)) {
          return showToast(`Stamp Paper Row ${i + 1}: Invalid characters in Stamp Number`);
        }
      }
    }


    // ----------------------------------------------------------------
    // 4. CONSTRUCT SUMMARY HTML (Like Model)
    // ----------------------------------------------------------------

    // Helper functions for detailed party extraction
    const formatPartyDetails = (arr, key) => {
      const formatted = arr.map(item => {
        const d = item[key];
        if (!d || !d.name) return null;
        let details = `<div style="margin-bottom: 6px;"><strong>${d.name.toUpperCase()}</strong>`;
        if (d.cid) details += ` <span style="background: #e9ecef; padding: 1px 6px; border-radius: 4px; font-size: 10px;">${d.cid}</span>`;
        if (d.mobile) details += ` <br/><span style="font-size: 11px; color: #555;">📞 ${d.mobile}</span>`;
        if (d.city) details += ` <span style="font-size: 11px; color: #555;">📍 ${d.city.toUpperCase()}</span>`;
        details += `</div>`;
        return details;
      }).filter(Boolean);
      
      return formatted.length > 0 ? formatted.join('<div style="border-top: 1px dashed #ddd; margin: 4px 0;"></div>') : 'N/A';
    };

    const buyersHtml = formatPartyDetails(buyer_Details, 'buyer_Detail');
    const sellersHtml = formatPartyDetails(seller_Details, 'seller_Detail');
    const witnessHtml = formatPartyDetails(witness_Details, 'witness_Detail');

    // Document & Stamp Arrays
    const parentDocsHtml = parent_document.filter(d => d.type || d.number).length > 0 
      ? parent_document.map(d => `<div style="display: flex; justify-content: space-between; border-bottom: 1px solid #f0f0f0; padding: 2px 0;"><span>${d.type || 'Doc'}</span> <strong>${d.number || 'N/A'}</strong></div>`).join('') 
      : 'N/A';

    const stampsHtml = stamp_Paper.filter(s => s.value || s.number).length > 0 
      ? stamp_Paper.map(s => `<div style="display: flex; justify-content: space-between; border-bottom: 1px solid #f0f0f0; padding: 2px 0;"><span>₹${s.value || '0'}</span> <strong>${s.number || 'N/A'}</strong></div>`).join('') 
      : 'N/A';

    // Status Badge Helper
    const getBadge = (val, extraText = "") => {
      if (val === 'yes') return `<span style="color: #198754; font-weight: bold;">YES ${extraText ? `<span style="color: #333; font-weight: 600;">(${extraText})</span>` : ''}</span>`;
      if (val === 'no') return `<span style="color: #dc3545; font-weight: bold;">NO</span>`;
      return `<span style="color: #6c757d; font-weight: bold; font-size: 11px;">PENDING</span>`;
    };

    // --- NEW: File Indicator Helper ---
    const getFileIndicator = (stage) => {
      if (stage?.file && stage.file instanceof File) {
        // Shows the name of the newly selected file
        return `<div style="margin-top: 4px;"><span style="font-size: 10px; color: #084298; background-color: #cfe2ff; padding: 2px 6px; border-radius: 4px; border: 1px solid #b6d4fe;">📎 ${stage.file.name}</span></div>`;
      } else if (stage?.fileData?.url) {
        // Indicates an existing file is already saved in the database
        const fileName = stage.fileData.path ? stage.fileData.path.split('/').pop() : 'Saved File';
        return `<div style="margin-top: 4px;"><span style="font-size: 10px; color: #0f5132; background-color: #d1e7dd; padding: 2px 6px; border-radius: 4px; border: 1px solid #badbcc;">📎 ${fileName}</span></div>`;
      }
      return '';
    };

    const summaryHtml = `
      <div style="text-align: left; font-size: 13px; color: #333; font-family: 'Segoe UI', Tahoma, sans-serif; line-height: 1.5; max-height: 65vh; overflow-y: auto; padding-right: 8px;">
        
        <div style="position: sticky; top: 0; background: rgba(255, 255, 255, 0.95); backdrop-filter: blur(4px); display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px; padding-bottom: 10px; border-bottom: 2px solid #8a2be2; z-index: 10;">
            <div>
              <span style="font-size: 18px; color: #4a127e;"><strong># ${ app_No || 'NEW'}</strong></span>
              <div style="font-size: 11px; color: #6c757d; margin-top: 2px;">Date: ${date || new Date().toISOString().split('T')[0]}</div>
              <div style="font-size: 11px; color: #6c757d; margin-top: 2px;">Document Date: ${individual.document_date || new Date().toISOString().split('T')[0]}</div>
            </div>
        </div>
        
        <div style="background-color: #f8f9fa; padding: 12px; border-radius: 8px; margin-bottom: 15px; border: 1px solid #e9ecef;">
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
            <div><span style="color: #6c757d; font-size: 11px; text-transform: uppercase;">Zone</span><br/><strong>${typeof zone === 'string' ? zone.toUpperCase() : zone?.label || 'N/A'}</strong></div>
            <div><span style="color: #6c757d; font-size: 11px; text-transform: uppercase;">Office</span><br/><strong>${typeof off === 'string' ? off.toUpperCase() : off?.label || 'N/A'}</strong></div>
            <div><span style="color: #6c757d; font-size: 11px; text-transform: uppercase;">Village</span><br/><strong>${typeof vill === 'string' ? vill.toUpperCase() : vill?.label || 'N/A'}</strong></div>
            <div><span style="color: #6c757d; font-size: 11px; text-transform: uppercase;">Document Type</span><br/><strong>${typeof doc === 'string' ? doc.toUpperCase() : doc?.label || 'N/A'}</strong></div>
            <div style="grid-column: span 2; border-top: 1px dashed #ccc; padding-top: 6px; mt-1;">
               <span style="color: #6c757d; font-size: 11px; text-transform: uppercase;">Managed By</span><br/>
               <strong>${users1.map(u => u.label).join(', ') || 'N/A'}</strong>
            </div>
          </div>
        </div>

        <div style="margin-bottom: 15px; border: 1px solid #dee2e6; border-radius: 8px; overflow: hidden;">
          <div style="background-color: #f1f3f5; padding: 8px 12px; font-size: 12px; font-weight: bold; color: #495057; border-bottom: 1px solid #dee2e6;">
             CLIENTS & PARTIES
          </div>
          <div style="padding: 12px;">
            <p style="margin: 0 0 10px 0;"><strong>Referred By:</strong> <span style="color: #8a2be2;">${ref1?.value?.name?.toUpperCase() || 'DIRECT'}</span></p>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
              <div style="background: #e6f2ff; padding: 8px; border-radius: 6px; border: 1px solid #cce5ff;">
                <div style="font-size: 11px; color: #004085; font-weight: bold; margin-bottom: 4px; text-transform: uppercase;">Buyer(s)</div>
                ${buyersHtml}
              </div>
              <div style="background: #fff3cd; padding: 8px; border-radius: 6px; border: 1px solid #ffeeba;">
                <div style="font-size: 11px; color: #856404; font-weight: bold; margin-bottom: 4px; text-transform: uppercase;">Seller(s)</div>
                ${sellersHtml}
              </div>
            </div>
            <div style="margin-top: 12px; background: #f8f9fa; padding: 8px; border-radius: 6px; border: 1px solid #e9ecef;">
              <div style="font-size: 11px; color: #383d41; font-weight: bold; margin-bottom: 4px; text-transform: uppercase;">Witness(es)</div>
              ${witnessHtml}
            </div>
          </div>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 15px;">
          <div style="border: 1px solid #dee2e6; border-radius: 8px; padding: 10px;">
             <h6 style="margin: 0 0 8px 0; color: #4a127e; font-size: 12px; text-transform: uppercase;">Land Details</h6>
             <table style="width: 100%; font-size: 12px;">
                <tr><td style="color:#6c757d; padding: 2px 0;">SF No:</td><td style="text-align: right; font-weight: bold;">${individual.sfno || '-'}</td></tr>
                <tr><td style="color:#6c757d; padding: 2px 0;">Site No:</td><td style="text-align: right; font-weight: bold;">${individual.siteno || '-'}</td></tr>
                <tr><td style="color:#6c757d; padding: 2px 0;">Layout:</td><td style="text-align: right; font-weight: bold;">${typeof layout === 'string' ? layout.toUpperCase() : layout?.label || 'N/A'}</td></tr>
             </table>
          </div>
          <div style="border: 1px solid #dee2e6; border-radius: 8px; padding: 10px; background-color: #fafafa;">
             <h6 style="margin: 0 0 8px 0; color: #4a127e; font-size: 12px; text-transform: uppercase;">Payment Info</h6>
             <div style="font-size: 12px; font-weight: bold; color: ${individual.payment_Info ? '#212529' : '#adb5bd'};">
               ${individual.payment_Info || 'No transaction details entered.'}
             </div>
             <div style="margin-top: 8px; border-top: 1px dashed #ccc; padding-top: 6px;">
               <span style="font-size: 11px; color:#6c757d;">Document Split:</span> <strong style="color: ${individual.document_Split === 'yes' ? '#8a2be2' : '#28a745'};">${individual.document_Split?.toUpperCase() || 'NO'}</strong>
             </div>
          </div>
        </div>

        <div style="display: flex; gap: 10px; margin-bottom: 15px;">
          <div style="flex: 1; background-color: #fff9e6; padding: 10px; border-radius: 8px; border: 1px solid #ffeba1;">
            <strong style="font-size: 11px; color: #b08d13; text-transform: uppercase; display: block; margin-bottom: 4px;">Parent Documents</strong>
            <div style="font-size: 12px;">${parentDocsHtml}</div>
          </div>
          <div style="flex: 1; background-color: #e6f9f0; padding: 10px; border-radius: 8px; border: 1px solid #a1e6c8;">
            <strong style="font-size: 11px; color: #158c54; text-transform: uppercase; display: block; margin-bottom: 4px;">Stamp Papers</strong>
            <div style="font-size: 12px;">${stampsHtml}</div>
          </div>
        </div>

        <div style="margin-bottom: 15px; border: 1px solid #8a2be2; border-radius: 8px; overflow: hidden;">
          <div style="background-color: #f9f7ff; padding: 8px 12px; font-size: 12px; font-weight: bold; color: #4a127e; border-bottom: 1px solid #e2d3f5;">
             DETAILED APPLICATION WORKFLOW
          </div>
          <div style="padding: 10px;">
            <table style="width: 100%; font-size: 12px; border-collapse: collapse;">
              <tbody>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                  <td style="padding: 6px 0; color: #555;">Guideline Verified</td>
                  <td style="text-align: right;">${getBadge(edit.value_check?.values, edit.value_check?.doc_value ? `₹${edit.value_check.doc_value}` : '')}/${status} </td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                  <td style="padding: 6px 0; color: #555;">Draft Prepared</td>
                  <td style="text-align: right;">${getBadge(edit.draft_prepared?.values)}</td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                  <td style="padding: 6px 0; color: #555;">Draft Sent</td>
                  <td style="text-align: right;">
                    ${getBadge(edit.draft_send?.values, edit.draft_send?.through)}
                    ${getFileIndicator(edit.draft_send)}
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                  <td style="padding: 6px 0; color: #555;">Draft Approved</td>
                  <td style="text-align: right;">${getBadge(edit.draft_approved?.values, edit.draft_approved?.by)}</td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                  <td style="padding: 6px 0; color: #555;">Already Applied EC</td>
                  <td style="text-align: right;">${alreadyAppliedEc === "yes"
                    ? `<span style="color: #198754; font-weight: bold;">YES</span>${linkedEc?.ec ? ` <span style="color: #333;">(${linkedEc.ec.application_no || ""} / ${(linkedEc.ec.owner?.name || "N/A").toUpperCase()})</span>` : ""}`
                    : `<span style="color: #dc3545; font-weight: bold;">NO</span>`}</td>
                </tr>
                ${alreadyAppliedEc === "yes" ? "" : `
                <tr style="border-bottom: 1px solid #f0f0f0;">
                  <td style="padding: 6px 0; color: #555;">EC Application</td>
                  <td style="text-align: right;">${getBadge(edit.certificate_applied?.values, edit.certificate_applied?.eca_no ? `ECA: ${edit.certificate_applied.eca_no}` : '')}</td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                  <td style="padding: 6px 0; color: #555;">EC Received</td>
                  <td style="text-align: right;">
                    ${getBadge(edit.certificate_received?.values)}
                    ${getFileIndicator(edit.certificate_received)}
                  </td>
                </tr>
                `}
                <tr style="border-bottom: 1px solid #f0f0f0;">
                  <td style="padding: 6px 0; color: #555;">Temp Deed (TP)</td>
                  <td style="text-align: right;">${getBadge(edit.deed_no?.values, edit.deed_no?.tp_no)}</td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                  <td style="padding: 6px 0; color: #555;">Token Initiated</td>
                  <td style="text-align: right;">
                    ${getBadge(edit.token_initiated?.values, edit.token_initiated?.token_no ? `${edit.token_initiated.token_no} | ${edit.token_initiated.time || ''}` : '')}
                    ${getFileIndicator(edit.token_initiated)}
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0; background-color: ${edit.document_registered?.values === 'yes' ? '#f0fdf4' : 'transparent'};">
                  <td style="padding: 6px 0; color: #000; font-weight: 500;">Final Registration</td>
                  <td style="text-align: right;">
                    ${getBadge(edit.document_registered?.values, edit.document_registered?.document_no)}
                    ${getFileIndicator(edit.document_registered)}
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0; background-color: ${edit.document_pending?.values === 'yes' ? '#fff5f5' : 'transparent'};">
                  <td style="padding: 6px 0; color: #000; font-weight: 500;">Pending Status</td>
                  <td style="text-align: right;">${edit.document_pending?.values === "no" ? '<span style="color: #dc3545; font-weight: bold;">NO</span>' :`<span style="color: #198754; font-weight: bold;">YES ${edit.document_pending?.document_no ? `<span style="color: #333; font-weight: 600;">(${edit.document_pending?.document_no})</span>` : ''}</span>`}</td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0;">
                  <td style="padding: 6px 0; color: #555;">Document Scanned</td>
                  <td style="text-align: right;">
                    ${getBadge(edit.document_scanned?.values)}
                    ${getFileIndicator(edit.document_scanned)}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 6px 0; color: #555;">Handover/Collected</td>
                  <td style="text-align: right;">
                    ${getBadge(edit.document_collected?.values)} 
                    ${edit.other?.values === 'yes' && edit.other?.cusDetail?.name ? `<br/><small style="color: #8a2be2;">(By: ${edit.other.cusDetail.name})</small>` : ''}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div style="background-color: #212529; color: white; padding: 15px; border-radius: 8px; display: flex; justify-content: space-between; align-items: center;">
          <div>
            <div style="font-size: 11px; color: #adb5bd; text-transform: uppercase;">Payment Status</div>
            <div style="font-size: 14px; font-weight: bold; color: ${edit.payment?.values === 'yes' ? '#4ade80' : '#f87171'}; mt-1;">
              ${edit.payment?.values === 'yes' ? '<i class="bi bi-check-circle-fill"></i> SETTLED' : '<i class="bi bi-x-circle-fill"></i> PENDING'}
            </div>
          </div>
          <div style="text-align: right;">
            <div style="font-size: 11px; color: #adb5bd; text-transform: uppercase;">Quotation</div>
            <div style="color: #4ade80; font-size: 22px; font-weight: bold; letter-spacing: 1px;">₹${individual.approximate_quatation || '0'}</div>
          </div>
        </div>

      </div>
    `;

    // 5. Fire SweetAlert Confirmation
    const result = await Swal.fire({
      title: 'Confirm Registration Details',
      html: summaryHtml,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#8a2be2",
    });

    if (!result.isConfirmed) return;
    setBt(true);


    // ----------------------------------------------------------------
    // 6.5. UPLOAD FILES TO SECONDARY FIREBASE STORAGE
    // ----------------------------------------------------------------
    
    const updatedFileData = {};

    // Mapping states to file name suffixes
    const fileStages = [
      { key: 'draft_send', suffix: 'draft' },
      { key: 'certificate_received', suffix: 'ec' },
      { key: 'token_initiated', suffix: 'token' },
      { key: 'document_registered', suffix: 'registered' },
      { key: 'document_scanned', suffix: 'scanned' }
    ];

    try {
      for (const stage of fileStages) {
        const currentStage = edit[stage.key];
        
        // 1. Check if there is a NEW File object to upload
        if (currentStage?.file && currentStage.file instanceof File) {
          // Folder: document / App_No / App_no_suffix.pdf
          const storagePath = `document/${app_No.replaceAll('/', '_')}/${app_No.replaceAll('/', '_')}_${stage.suffix}.pdf`;
          
          // USE YOUR SECONDARY STORAGE INSTANCE HERE
          const fileRef = ref(storage, storagePath);
          
          await uploadBytes(fileRef, currentStage.file);
          const downloadURL = await getDownloadURL(fileRef);
          
          updatedFileData[stage.key] = { url: downloadURL, path: storagePath };
        } 
        // 2. Otherwise, keep the existing fileData (if already uploaded previously)
        else if (currentStage?.fileData) {
          updatedFileData[stage.key] = currentStage.fileData;
        }
      }
    } catch (uploadError) {
      console.error("Firebase Upload Error:", uploadError);
      setBt(false);
      return showToast("Failed to upload files to Firebase Storage. Please try again.");
    }
    // ----------------------------------------------------------------*/


    // 6. Click Increment Logic (from Model)
    const processClicks = (field) => {
      const currentField = edit[field];
      if (!currentField) return currentField;
      
      // Remove raw 'file' object so it doesn't get sent to your JSON API
      const { file, ...safeField } = currentField;

      return {
        ...safeField,
        // Attach the uploaded URL/Path if it exists for this field
        fileData: updatedFileData[field] || safeField.fileData || null,
        clicked: safeField.values !== null && safeField.values !== undefined 
          ? ((safeField.clicked || 0) + 1) 
          : 0
      };
    };

    // 7. Assemble Payload
    const userList = users1.map(u => u.value);
    
    const payload = {
      application_no: app_No,
      date: date,
      zone: typeof zone === 'string' ? zone.toLowerCase() : zone?.value?.toLowerCase() || "",
      register_office: typeof off === 'string' ? off.toLowerCase() : off?.value?.toLowerCase() || "",
      document_date: individual.document_date,
      register_document: typeof doc === 'string' ? doc.toLowerCase() : doc?.value?.toLowerCase() || "",
      managed_By: userList,
      refered_by: ref1?.value || {},
      buyers: buyer_Details,
      sellers: seller_Details,
      witness: witness_Details,
      village: typeof vill === 'string' ? vill.toLowerCase() : vill?.value?.toLowerCase() || "",
      layout_name: typeof layout === 'string' ? layout.toLowerCase() : layout?.value?.toLowerCase() || "",
      sfno: individual.sfno,
      site_no: individual.siteno,
      parent_document: parent_document,
      approximate_quatation: individual.approximate_quatation,
      document_split: individual.document_Split || data.document_split,
      
      // --- NEWLY ADDED FIELDS TO PAYLOAD ---
      remarks: individual.remarks || "",
      internal_notes: individual.internal_notes || "",
      
      // Applying processClicks strictly to the 9-stage tracking objects
      value_check: processClicks('value_check'),
      draft_prepared: processClicks('draft_prepared'),
      draft_send: processClicks('draft_send'),
      draft_approved: processClicks('draft_approved'),
      certificate_applied: processClicks('certificate_applied'),
      certificate_received: processClicks('certificate_received'),
      already_applied_ec: alreadyAppliedEc === "yes" ? "yes" : "no",
      linked_ec: alreadyAppliedEc === "yes" && linkedEc?.ec
        ? {
            id: linkedEc.ec.id || "",
            application_no: linkedEc.ec.application_no || "",
            owner_name: linkedEc.ec.owner?.name || "",
            register_office: typeof linkedEc.ec.register_office === "string"
              ? linkedEc.ec.register_office
              : "",
            docstatus: linkedEc.ec.docstatus || "",
            ...(linkedEc.ec.ecno
              ? {
                  ecno: {
                    values: linkedEc.ec.ecno.values ?? null,
                    no: linkedEc.ec.ecno.no || "",
                    clicked: linkedEc.ec.ecno.clicked || 0,
                  },
                }
              : {}),
          }
        : null,
      deed_no: processClicks('deed_no'),
      token_initiated: processClicks('token_initiated'),
      stamp_Paper: hasStampPaper === "yes" ? stamp_Paper : [],
      payment_Info: individual.payment_Info,
      document_registered: processClicks('document_registered'),
      document_pending: processClicks('document_pending'),
      document_collected: processClicks('document_collected'),
      document_scanned: processClicks('document_scanned'),
      payment: processClicks('payment'),
      other: processClicks('other'),
      status: status,
      docstatus:"processing", 
    };

    // 8. API Call & Reset Protocol
    try {
      const new_doc = await api.post('/add_Customer', payload);
      const docMsg = new_doc.data.message;
      
      // Refresh Tables & Counts
      fetchDocuments();
      await api.put('doc_count', { year: new Date().getFullYear().toString() });
      fetchcountdoc();
      Swal.fire({
        text: docMsg,
        icon: "success",
        width: "28em",
        scrollbarPadding: false,
        timer: 2000,
        showConfirmButton: false,
        timerProgressBar: true 
      });

      // 9. Reset ALL Form States
      set_ref({ value: "", label: "" });
      set_vill({ value: "", label: "" });
      set_zone(null);
      set_off({ value: "", label: "" });
      set_doc({ value: "", label: "" });
      
      set_Buyer_Details([{ buyer_Detail: {}, buyer_aadhar: "" }]);
      set_Seller_Details([{ seller_Detail: {}, seller_aadhar: "" }]);
      set_Witness_Details([{ witness_Detail: {}, witness_aadhar: "" }, { witness_Detail: {}, witness_aadhar: "" }]);
      
      setFormData({ zoneId: '', officeId: '', villageId: '', layoutId: '' });
      
      // --- NEWLY ADDED FIELDS TO RESET PROTOCOL ---
      if (typeof set_Individual === 'function') {
         set_Individual({ 
           sfno: "", 
           siteno: "", 
           approximate_quatation: "", 
           document_Split: "no", 
           payment_Info: "",
           remarks: "",
           internal_notes: "" 
         });
      }

      // Reset Wizard UI to Step 1
      if (typeof setCurrentStep === 'function') setCurrentStep(1);
      set_Stamp_Paper([{ value: "", number: "" }]);
      setHasStampPaper("yes");
      setAlreadyAppliedEc("no");
      setLinkedEc(null);

    set_Edit({
      draft_send: { clicked: 0, values: null, through: '', file: null, fileData: null },
    
    value_check: { clicked: 0, values: null, doc_value: "" },
    draft_prepared: { clicked: 0, values: null },
    draft_approved: { clicked: 0, values: null, by: "" },
    certificate_applied: { clicked: 0, values: null, eca_no: "" },
    
    // Added file and fileData to Certificate
    certificate_received: { clicked: 0, values: null, file: null, fileData: null },
    
    deed_no: { clicked: 0, values: null, tp_no: '' },
    
    // Added file and fileData to Token
    token_initiated: { clicked: 0, values: null, token_no: "", time: "", file: null, fileData: null },
    
    // Added file and fileData to Registered Document
    document_registered: { clicked: 0, values: null, document_no: "", file: null, fileData: null },
    
    document_pending: { clicked: 0, values: "no", document_no: "" },
    document_collected: { clicked: 0, values: null },
    
    // Added file and fileData to Scanned Document
    document_scanned: { clicked: 0, values: null, file: null, fileData: null },
    
    payment: { clicked: 0, values: null },
    other: { clicked: 0, values: null, cusDetail: null },
    });

      
      get_document();
      defaultn();
      get_customer();
      
      setTimeout(() => {
        window.scroll({ top: 100, left: 0, behavior: "smooth" });
      }, 3000);

    } catch (error) {
      console.error(error.message);
      if (typeof showToast === 'function') {
         showToast(error.response?.data?.message || error.message);
      }
    } finally {
      setBt(false);
    }
  };

  const formOffices = useMemo(() => (sOffice || []).filter(o => o.zoneId === formData.zoneId), [formData.zoneId, sOffice]);
const formVillages = useMemo(() => (sVillage || []).filter(v => v.officeId === formData.officeId), [formData.officeId, sVillage]);
const formLayout = useMemo(() => (sLayout || []).filter(v => v.villageId === formData.villageId), [formData.villageId, sLayout]);

  const handleAddLayout = (inputValue) => {
  if (!formData.villageId) {
    Swal.fire('Wait!', 'Please select a village first', 'warning');
    return;
  }

  Swal.fire({
    title: 'Add New Layout',
    input: 'text',
    inputValue: inputValue, // Pre-fills the popup with what the user just typed!
    inputLabel: 'Layout Name',
    showCancelButton: true,
    confirmButtonColor: '#6f42c1', 
    inputValidator: (value) => {
      if (!value) return 'Layout name is required!';
      const regex = /^[a-zA-Z0-9\s-]+$/; 
      if (!regex.test(value)) return 'Letters, numbers, and hyphens only!';
    }
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        Swal.showLoading();
        // Assuming your backend returns the newly created object ID in res.data
        await api.post("/add_v_s", {
          type: "layout",
          name: result.value.trim().toLowerCase(),
          parentId: formData.villageId 
        });
        
        await fetchSLayout(); 
        Swal.fire({ icon: 'success', title: 'Added!', timer: 1500, showConfirmButton: false });

        // OPTIONAL: Auto-select the newly created layout if your API returns its ID
        // if (res.data?.id) {
        //   setFormData({ ...formData, layoutId: res.data.id });
        //   set_Layout(result.value.trim().toUpperCase());
        // }

      } catch (error) {
        Swal.fire('Error', error.response?.data?.message || 'Failed to add', 'error');
      }
    }
  });
};

  // --- Nature of Document Creation ---
  const handleCreate_doc = async (value) => {
    const add = value.trim().toLowerCase().replace(/\s+/g, ' ');
    if (!/^[A-Za-z ]+$/.test(add)) {
      return showToast("Can't Add Special Character at Nature of Document");
    }
    const result = await Swal.fire({
      title: "Confirm Document Type",
      text: `Do you want to add "${add}" to the document list?`,
      icon: "question",
      width: "28em",
      showCancelButton: true,
      confirmButtonColor: "#8a2be2", // Themed Purple
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, add it",
      scrollbarPadding: false,
    });
    
    if (result.isConfirmed) {
      try {
        const res = await api.post('/add_New_Document', { doc_Name: add });
        await Swal.fire({
          text: res.data.message,
          icon: "success",
          width: "28em",
          timer: 2000,
          showConfirmButton: false,
          timerProgressBar: true 
        });
        fetchDocs();
      } catch (error) {
        showToast("Error: Could not save the document type.");
      }
    }
  };

  const handleCreate_cus = () => {
    setAdd(true)
    setDim(true)
    get_customer()
  }


  
    const handleAddstamp_Paper = () => {
      set_Stamp_Paper([...stamp_Paper,{
        value: "",
        number: ""
      }])
    }
  
    const handleChangestamp_Papervalue = (index, val) => {
    const values = [...stamp_Paper];
    values[index].value = val ;
    set_Stamp_Paper(values);
  };
  
  const handleChangestamp_Papernumber = (index, val) => {
    const values = [...stamp_Paper];
    values[index].number = val;
    set_Stamp_Paper(values);
  };
  
    const handleRemovestamp_Paper = (index) => {
      const values = [...stamp_Paper];
      values.splice(index, 1);
      set_Stamp_Paper(values);
    }

  const timeOptions = [
  { value: "10 AM - 11 AM", label: "10 AM - 11 AM" },
  { value: "11 AM - 12 PM", label: "11 AM - 12 PM" },
  { value: "12 PM - 1 PM", label: "12 PM - 1 PM" },
  { value: "1 PM - 1:30 PM", label: "1 PM - 1:30 PM" },
  { value: "2 PM - 3 PM", label: "2 PM - 3 PM" },
  { value: "3 PM - 3:30 PM", label: "3 PM - 3:30 PM" }
];

  const handleAddBuyer = () => {
    set_Buyer_Details([...buyer_Details, { buyer_Detail: {}, buyer_aadhar: "" }]);
  };

  const handleChangeOptionBuy = (index, newVal, actionMeta) => {
    let values = [...buyer_Details];
    values[index].buyer_Detail = actionMeta.action === 'select-option' ? newVal.value : {};
    set_Buyer_Details(values);
  };

  const handleRemoveBuyer = (index) => {
    const values = [...buyer_Details];
    values.splice(index, 1);
    set_Buyer_Details(values);
  };

  const handleAddSeller = () => {
    set_Seller_Details([...seller_Details, { seller_Detail: {}, seller_aadhar: "" }]);
  };

  const handleChangeOptionSel = (index, newVal, actionMeta) => {
    let values = [...seller_Details];    
    values[index].seller_Detail = actionMeta.action === 'select-option' ? newVal.value : {};
    set_Seller_Details(values);
  };

  const handleRemoveSeller = (index) => {
    const values = [...seller_Details];
    values.splice(index, 1);
    set_Seller_Details(values);
  };

  const handleChangeOptionWit = (index, newVal, actionMeta) => {
    let values = [...witness_Details];
    values[index].witness_Detail = actionMeta.action === 'select-option' ? newVal.value : {};
    set_Witness_Details(values);
  };

  const handleAddparent_Document = () => {
    set_Parent_Document([...parent_document,{
      type: "",
      number: ""
    }])
  }

  const handleChangeparent_Documenttype = (index, val) => {
  const values = [...parent_document];
  values[index].type = val ? val.value : null;
  set_Parent_Document(values);
};

const handleChangeparent_Documentnumber = (index, val) => {
  const values = [...parent_document];
  values[index].number = val;
  set_Parent_Document(values);
};

  const handleRemoveparent_Document = (index) => {
    const values = [...parent_document];
    values.splice(index, 1);
    set_Parent_Document(values);
  }

  const stageStatus = useMemo(() => {
    // --- STAGE 1: Reference & Applicant ---
    const isStep1Complete = !!(formData.zoneId && formData.officeId && users1.length > 0 && users1.every(user => !!user) && individual.document_date && doc  && ref1?.value && buyer_Details.length > 0 && buyer_Details.every(b => !!b.buyer_Detail?.name) && seller_Details.length > 0 && seller_Details.every(s => !!s.seller_Detail?.name) && witness_Details.length > 0 && witness_Details.every(w=>!!w.witness_Detail.name));
    
    // --- STAGE 2: Property & Land ---
    const isStep2Complete = !!(formData.villageId && formData.layoutId && individual.approximate_quatation && individual.sfno.trim() !== "" && individual.siteno.trim() !== "" && parent_document.length > 0 && parent_document.every(doc => doc.type !== "" && doc.number?.trim() !== ""));
    
    // --- STAGE 3: Guideline Value ---
    const isStep3Complete = status === 'offline' ? (edit.value_check.values === 'yes' || edit.value_check.values === 'no') : (edit.value_check.values === 'no' || (edit.value_check.values === 'yes' && edit.value_check.doc_value.trim() !== ""));
    
    // --- STAGE 4: Offline Draft (skipped when Presenceless = Online) ---
    const isStep4Complete = status === 'online' ? true : !!(
        edit.draft_prepared.values && 
        (edit.draft_send.values === "yes" 
            ? edit.draft_send.through?.trim() !== "" && (
                edit.draft_send.through === "online" 
                    ? !!edit.draft_send.file // Must have a file if online
                    : true
              )
            : edit.draft_send.values
        ) && 
        (edit.draft_approved.values === 'no' ? true : (edit.draft_approved.values === 'yes' && edit.draft_approved.by?.trim() !== ""))
    );
    
    // --- STAGE 5: EC Process (Requires new file) ---
    const isCertificateReceivedComplete = edit.certificate_received.values === 'yes'
      ? !!edit.certificate_received.file
      : edit.certificate_received.values;
    const isStep5Complete = alreadyAppliedEc === "yes"
      ? !!(linkedEc?.ec?.id && isCertificateReceivedComplete)
      : !!(
        (edit.certificate_applied.values === 'yes' ? (edit.certificate_applied.eca_no.trim() !== "") : edit.certificate_applied.values) && 
        isCertificateReceivedComplete
      );
    
    // --- STAGE 6: Online Draft (Token hidden when Presenceless = Online) ---
    const isStep6Complete = status === 'online'
      ? !!(edit.deed_no.values === 'yes' ? (edit.deed_no.tp_no.trim() !== "") : edit.deed_no.values)
      : !!(
        (edit.deed_no.values === 'yes' ? (edit.deed_no.tp_no.trim() !== "") : edit.deed_no.values) && 
        (edit.token_initiated.values === 'yes' 
            ? (edit.token_initiated.token_no.trim() !== "" && edit.token_initiated.time && !!edit.token_initiated.file) 
            : edit.token_initiated.values)
    );
    
    // --- STAGE 7: Registration Process ---
    const isStampPaperComplete = hasStampPaper === "no" || (stamp_Paper.length > 0 && stamp_Paper.every(s => s.value !== "" && s.number?.trim() !== ""));
    const isPendingComplete = status === 'online'
      ? true
      : (edit.document_pending.values === 'yes' ? (edit.document_pending.document_no.trim() !== "") : edit.document_pending.values);
    const isStep7Complete = !!(isStampPaperComplete && individual.payment_Info?.trim() && isPendingComplete && (edit.document_registered.values === 'yes' ? (edit.document_registered.document_no.trim() !== ""): edit.document_registered.values));
    
    // --- STAGE 8: Return Collection (Processing) (Requires new file) ---
    // Presenceless Online: Collection Status hidden — only scanned/downloaded required
    const isScannedComplete = edit.document_scanned.values === 'yes' 
      ? !!edit.document_scanned.file 
      : edit.document_scanned.values;
    const isStep8Complete = status === 'online'
      ? !!isScannedComplete
      : !!(edit.document_collected.values && isScannedComplete);
    
    // --- STAGE 9: Application Completed (Settlement) ---
    const isStep9Complete = !!(edit.payment.values && (edit.other.values === 'yes' ? (!!edit.other.cusDetail && !!edit.other.cusDetail.name) : (edit.other.values === 'no')));

    return {
      1: isStep1Complete,
      2: isStep2Complete,
      3: isStep3Complete,
      4: isStep4Complete,
      5: isStep5Complete,
      6: isStep6Complete,
      7: isStep7Complete,
      8: isStep8Complete,
      9: isStep9Complete,
    };
// Removed `isAlreadyCompleted` from dependency array
}, [formData, individual, parent_document, doc, users1, ref1, buyer_Details, seller_Details, witness_Details, edit, status, stamp_Paper, hasStampPaper, alreadyAppliedEc, linkedEc]);

  const steps = [
  { id: 1, label: "Referred & Client Details", complete: stageStatus[1] },
  { id: 2, label: "Diocument Details", complete: stageStatus[2] },
  { id: 3, label: "Guideline Value", complete: stageStatus[3] },
  { id: 4, label: "Offline Draft", complete: stageStatus[4] },
  { id: 5, label: "EC", complete: stageStatus[5] },
  { id: 6, label: "Online Draft", complete: stageStatus[6] },
  { id: 7, label: "Registration Process", complete: stageStatus[7] },
  { id: 8, label: "Return Collection", complete: stageStatus[8] },
  { id: 9, label: "Application Completed", complete: stageStatus[9] },
].filter(step => !(status === 'online' && step.id === 4));

  // Skip Offline Draft (step 4) when Presenceless is Online
  useEffect(() => {
    if (status === 'online' && currentStep === 4) {
      setCurrentStep(5);
    }
  }, [status, currentStep]);

  const getAdjacentStep = (from, direction) => {
    let next = from + direction;
    if (status === 'online' && next === 4) {
      next = from + (direction * 2);
    }
    return next;
  };

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '38px',
      borderRadius: '0.375rem',
      borderColor: state.isFocused ? 'var(--brand-purple)' : '#dee2e6',
      boxShadow: state.isFocused ? '0 0 0 1px var(--brand-purple)' : 'none',
      '&:hover': {
        borderColor: 'var(--brand-purple)'
      }
    }),
    // This ensures the menu is physically moved to the <body> 
    // so it ignores "overflow: hidden" on your Cards
    menuPortal: (base) => ({ 
      ...base, 
      zIndex: 9999 
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected 
        ? 'var(--brand-purple)' 
        : state.isFocused 
        ? 'rgba(74, 18, 126, 0.1)' 
        : 'white',
      color: state.isSelected ? 'white' : 'var(--bs-body-color)',
    })
  };

  const handleIndividualChange = (e) => {
    const { name, value } = e.target;
    set_Individual(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validateCurrentStep = (stepToValidate = currentStep) => {
  switch (stepToValidate) {
        case 1:
            if (!formData.zoneId) { showToast("Please select a Zone."); return false; }
            if (!formData.officeId) { showToast("Please select an Office."); return false; }
            if (!users1 || users1.length === 0 || !users1.every(user => !!user)) { showToast("Please assign at least one User."); return false; }
            if (!individual.document_date) { showToast("Please select a Document Date."); return false; }
            if (!doc) { showToast("Please select a Register Document."); return false; }
            break;

        case 2:
            // Handled cleanly by your optional setup
            break;

        case 3:
            if (status === 'online' && edit.value_check.values === 'yes') {
                if (!edit.value_check.doc_value || edit.value_check.doc_value.toString().trim() === '') {
                    showToast("Please enter the Guideline Value before proceeding.");
                    return false; 
                }
            }
            break;

        case 4:
            // Offline Draft is hidden when Presenceless = Online
            if (status === 'online') break;
            if (edit.draft_send.values === "yes" && !edit.draft_send.through?.trim() ) { showToast("Please specify how the draft was sent (through)."); return false; }
            if (edit.draft_approved.values === "yes" && !edit.draft_approved.by?.trim()) { showToast("Please specify who approved the draft (by)."); return false; }
            
            // --- CREATION MODE: Strictly check for new uploaded Draft file if 'online' ---
            if (edit.draft_send.values === "yes" && edit.draft_send.through === "online" && !edit.draft_send.file) { 
                showToast("Please upload the Draft PDF."); return false; 
            }
            break;

        case 5:
            if (alreadyAppliedEc === "yes") {
                if (!linkedEc?.ec?.id) { showToast("Please select an already applied EC from the list."); return false; }
                if (edit.certificate_received.values === "yes" && !edit.certificate_received.file) { 
                    showToast("Please upload the Received Certificate PDF."); return false; 
                }
            } else {
                if (edit.certificate_applied.values === "yes" && !edit.certificate_applied.eca_no?.trim()) { showToast("Please enter the ECA No."); return false; }
                
                // --- CREATION MODE: Strictly check for new uploaded EC file ---
                if (edit.certificate_received.values === "yes" && !edit.certificate_received.file) { 
                    showToast("Please upload the Received Certificate PDF."); return false; 
                }
            }
            break;

        case 6:
            if (edit.deed_no.values === "yes" && !edit.deed_no.tp_no?.trim()) { showToast("Please enter the TP No."); return false; }
            // Token Initiated is hidden when Presenceless = Online
            if (status !== 'online') {
              if (edit.token_initiated.values === "yes" && (!edit.token_initiated.token_no?.trim() || !edit.token_initiated.time)) { showToast("Please provide both Token No and Time."); return false; }
              
              // --- CREATION MODE: Strictly check for new uploaded Token file ---
              if (edit.token_initiated.values === "yes" && !edit.token_initiated.file) { 
                  showToast("Please upload the Token Document PDF."); return false; 
              }
            }
            break;

        case 7:
            if (status !== 'online' && edit.document_pending.values === "yes" && !edit.document_pending.document_no?.trim()) { showToast("Please provide the Pending Document No."); return false; }
            if (edit.document_registered.values === "yes" && !edit.document_registered.document_no?.trim()) { showToast("Please provide the Registered Document No."); return false; }
            break;

        case 8:
            // --- CREATION MODE: Strictly check for new uploaded Scanned Document ---
            if (edit.document_scanned.values === "yes" && !edit.document_scanned.file) { 
                showToast("Please upload the Scanned Document PDF."); return false; 
            }
            break;

        case 9:
            if (edit.other.values === "yes" && (!edit.other.cusDetail || !edit.other.cusDetail.name)) { showToast("Please select the Recipient from the dropdown."); return false; }
            break;

        default:
            break;
    }

    return true; // All checks passed, allows navigation
};

const layoutOptions = formLayout
    .slice()
    .sort((a, b) => (a.layoutName || "").localeCompare(b.layoutName || ""))
    .map(v => ({
      value: v.id,
      label: v.layoutName.toUpperCase()
    }));

  const selectedLayout = layoutOptions.find(opt => opt.value === formData.layoutId) || null;

  return (
    <div className="dashboard-page bg-light min-vh-100">
      <Header />
      <ToastContainer autoClose={3000} />
      <div className="dashboard-wrapper">
        <div className="d-none"><Sidebar user={user} /></div>

        <main className="main-area py-4">
          <Container fluid="xxl">
            
            {/* MANDATORY HEADER: Application Details */}
            <Card className="shadow-sm border-0 mb-4 rounded-3" style={{ borderTop: '5px solid #8a2be2' }}>
              <Card.Header className="bg-white pt-3 border-0">
                <div className="d-flex align-items-center">
                  <div className="rounded-circle me-2" style={{ width: '10px', height: '10px', backgroundColor: '#8a2be2' }}></div>
                  <h5 className="fw-bold mb-0" style={{ color: '#4a127e', letterSpacing: '-0.5px' }}>
                    Application Details
                  </h5>
                </div>
              </Card.Header>
              
              <Card.Body className="px-4 pb-4">
                <Row className="g-4"> 
                  {/* Row 1 */}
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.75rem' }}>App No.</Form.Label>
                      <Form.Control readOnly value={app_No} className="bg-light border-0 fw-semibold" style={{ color: '#555' }} />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.75rem' }}>Date</Form.Label>
                      <Form.Control readOnly value={date} className="bg-light border-0 fw-semibold" style={{ color: '#555' }} />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.75rem' }}>Zone <span className="text-danger">*</span></Form.Label>
                      <Form.Select 
                        className="shadow-none border-secondary-subtle"
                        value={formData.zoneId} 
                        onChange={(e) => { 
                          setFormData({ ...formData, zoneId: e.target.value, officeId: '' }); 
                          set_zone(sZone.find(z => z.id === e.target.value)?.zoneName || ""); 
                        }}
                      >
                        <option value="">Select Zone</option>
                        {sZone.slice().sort((a, b) => a.zoneName.localeCompare(b.zoneName)).map(z => (<option key={z.id} value={z.id}>{z.zoneName.toUpperCase()}</option>))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  {/* Row 2 */}
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.75rem' }}>Office <span className="text-danger">*</span></Form.Label>
                      <Form.Select 
                        className="shadow-none border-secondary-subtle"
                        disabled={!formData.zoneId} 
                        value={formData.officeId} 
                        onChange={(e) => { 
                          setFormData({ ...formData, officeId: e.target.value }); 
                          set_off(formOffices.find(o => o.id === e.target.value)?.officeName || ""); 
                        }}
                      >
                        <option value="">Select Office</option>
                        {formOffices.slice().sort((a, b) => a.officeName.localeCompare(b.officeName)).map(o => <option key={o.id} value={o.id}>{o.officeName.toUpperCase()}</option>)}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label 
                        className="small fw-bold text-muted text-uppercase mb-1" 
                        style={{ fontSize: '0.75rem' }}
                      >
                        Document Date
                      </Form.Label>
                      <Form.Control 
                        type="date"
                        name="date" // CRITICAL: This must match the key in your state (e.g., individual.date)
                        className="bg-light border-0 fw-semibold shadow-none" 
                        style={{ color: '#555', cursor: 'pointer' }} 
                        value={individual.document_date || ''} 
                        onChange={(e)=>{set_Individual({...individual, document_date: e.target.value})}}
                        // Restricts selection: 'min' is set to Today's date (Disables past dates)
                        min={new Date().toISOString().split("T")[0]}
                        // Triggers red border if the date is empty
                        isInvalid={!individual.document_date}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please select today or a future date.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group className="position-relative"> {/* Added position-relative just in case */}
                      <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.75rem' }}>
                        Document Nature <span className="text-danger">*</span>
                      </Form.Label>
                      <CreatableSelect 
                        isClearable 
                        options={options_doc} 
                        value={doc} 
                        onChange={set_doc} 
                        placeholder="Search or type..." 
                        styles={selectStyles}
                        menuPortalTarget={document.body} // This "lifts" the menu out of the local CSS flow
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group className="position-relative">
                      <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.75rem' }}>
                        Managed By <span className="text-danger">*</span>
                      </Form.Label>
                      <Select 
                        isMulti 
                        isDisabled={user.role === "user"} 
                        options={option_User} 
                        value={users1} 
                        onChange={set_users} 
                        placeholder="Select users..."
                        styles={selectStyles}
                        menuPortalTarget={document.body}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4} className="d-flex align-items-end">
                    <Button
                      variant="primary"
                      size="sm"
                      className="w-100 fw-bold py-2 rounded-pill shadow-sm"
                      onClick={() => handleMsg('WELCOME', { app_no: app_No })}
                      style={{ backgroundColor: '#8a2be2', border: 'none', fontSize: '12px' }}
                    >
                      WELCOME MESSAGE
                    </Button>
                  </Col>

                  <Col md={4} className="d-flex align-items-end">
                    <div className="d-flex align-items-center gap-2 flex-wrap w-100">
                      <span className="small fw-bold text-muted text-uppercase" style={{ fontSize: '0.75rem' }}>
                        Presenceless
                      </span>
                      <div className="p-2 rounded-pill border bg-light d-flex align-items-center px-3 shadow-sm">
                        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                          <Typography sx={{ fontSize: '11px', color: status === 'offline' ? '#e7ac2d' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>Offline</Typography>
                          <AntSwitch
                            checked={status === 'online'}
                            onChange={(e) => setStatus(e.target.checked ? 'online' : 'offline')}
                          />
                          <Typography sx={{ fontSize: '11px', color: status === 'online' ? '#8a2be2' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>Online</Typography>
                        </Stack>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* STEPPER PROGRESS BAR */}
            {/* Added py-4 (vertical padding) and removed pb-3 to ensure nothing gets cut off */}
            <div className={`d-flex align-items-center mb-5 px-3 overflow-auto py-4 custom-scrollbar ${
              // Only center if the content is smaller than the screen
              // On mobile, this ensures it starts at the beginning (left-aligned)
              steps.length > 5 ? 'justify-content-start justify-content-md-center' : 'justify-content-center'
            }`}
            style={{ 
              WebkitOverflowScrolling: 'touch', // Smooth scrolling for iOS
              gap: '0' // Prevents unexpected gaps
            }}>
              {steps.map((step, index) => (
                <React.Fragment key={step.id}>
                  {/* --- STEP NODE --- */}
                  <div 
                    className="d-flex flex-column align-items-center position-relative" 
                    style={{ 
                      minWidth: '110px', // Slightly wider to accommodate longer labels like "Registration Process"
                      cursor: 'pointer',
                      padding: '5px 0' 
                    }}
                    onClick={() => {
                      // 1. If trying to navigate forward, validate every step sequentially up to the targe
                      // Temporarily change context for validation if your function depends on currentStep state,
                      // or pass the specific step index if you choose to update your function signature.
                      if (!validateCurrentStep(step.id-1)) return; // Stops execution immediately; toast is fired inside validateCurrentStep
                      // 2. If all validations pass (or they are navigating backward), jump to the target step
                      setCurrentStep(step.id);
                    }}
                  >
                    <div 
                      style={{
                        width: '44px', height: '44px', borderRadius: '50%',
                        display: 'flex', justifyContent: 'center', alignItems: 'center', 
                        fontWeight: '700', fontSize: '14px', transition: 'all 0.4s ease',
                        
                        // Halo effect for the currently active stage
                        boxShadow: currentStep === step.id 
                          ? '0 0 0 2px white, 0 0 0 5px #8a2be2' 
                          : '0 2px 5px rgba(0,0,0,0.05)',
                        
                        // Logic: Purple if complete, Yellow if current, White if pending
                        backgroundColor: step.complete ? '#8a2be2' : (currentStep === step.id ? '#ece917' : '#ffffff'),
                        color: step.complete ? '#ece917' : (currentStep === step.id ? '#4a127e' : '#adb5bd'),
                        border: (step.complete || currentStep === step.id) ? 'none' : '2px solid #e9ecef',
                        zIndex: 2,
                        transform: currentStep === step.id ? 'translateY(-3px)' : 'translateY(0)',
                      }}
                    >
                      {step.complete ? '✓' : (index + 1).toString().padStart(2, '0')}
                    </div>
                    
                    <span className="mt-2 fw-bold text-center text-uppercase" style={{ 
                      fontSize: '8.5px', // Smaller font to ensure 9 steps fit comfortably
                      letterSpacing: '0.5px',
                      maxWidth: '90px',
                      lineHeight: '1.2',
                      color: currentStep === step.id ? '#4a127e' : (step.complete ? '#8a2be2' : '#ced4da'),
                      transition: 'all 0.3s'
                    }}>
                      {step.label}
                    </span>
                  </div>

                  {/* --- LINE CONNECTOR --- */}
                  {index < steps.length - 1 && (
                    <div style={{ 
                      flex: '1', 
                      minWidth: '30px',
                      height: '6px', 
                      backgroundColor: '#f1f3f5', 
                      margin: '0 -20px', // Tucks line behind circles
                      marginBottom: '26px', // Aligns with center of 44px circle + label spacing
                      position: 'relative',
                      borderRadius: '10px',
                      zIndex: 1,
                      overflow: 'hidden'
                    }}>
                      <motion.div 
                        initial={false}
                        animate={{ width: step.complete ? '100%' : '0%' }} 
                        transition={{ duration: 0.5, ease: "easeInOut" }}
                        style={{ 
                          height: '100%', 
                          background: '#8a2be2',
                        }} 
                      />
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>

            <Form onSubmit={handleSubmit}>
              <AnimatePresence mode="wait">
                {/* STEP 1: Parties */}
                {currentStep === 1 && (
                  <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
                    <Card className="shadow-sm mb-4 border-0 rounded-3">
                      <Card.Header className="bg-white border-0 pt-4 px-4">
                        <h4 className="fw-bold mb-0" style={{ color: "#4a127e", letterSpacing: '-0.5px' }}>
                          Reference & Client Details
                        </h4>
                        <p className="text-muted small">Manage the primary parties involved in this application.</p>
                      </Card.Header>
                      
                      <Card.Body className="px-4 pb-4">
                        
                        {/* --- SECTION: REFERRED BY --- */}
                        <div className="mb-5 p-3 rounded-3" style={{ backgroundColor: '#f8f9fa' }}>
                          <h6 className="text-uppercase fw-bold mb-3 d-flex align-items-center" style={{ color: '#8a2be2', fontSize: '0.8rem' }}>
                            <span className="me-2">Referred By</span>
                            <hr className="flex-grow-1 my-0 opacity-10" />
                          </h6>
                          <Row className="g-3">
                            <Form.Group as={Col} xs={12} md={3}>
                              <Form.Label className="small fw-bold text-muted text-uppercase">Name {ref1?.value?.cid && <span className="badge bg-primary ms-1">{ref1.value.cid}</span>}</Form.Label>
                              <CreatableSelect
                                isClearable
                                value={ref1 ? { value: ref1.value, label: ref1.value?.name?.toUpperCase() } : null}
                                options={options || []}
                                onCreateOption={handleCreate_cus}
                                placeholder="Search..."
                                onChange={(val) => set_ref(val)}
                                styles={selectStyles} // Applied the zIndex fix
                              />
                            </Form.Group>
                            <Form.Group as={Col} xs={12} md={3}>
                              <Form.Label className="small fw-bold text-muted text-uppercase">Address</Form.Label>
                              <Form.Control readOnly value={TitleCase(ref1?.value?.address)} className="bg-white border-0 shadow-none" style={{ fontSize: '14px' }} />
                            </Form.Group>
                            <Form.Group as={Col} xs={12} md={3}>
                              <Form.Label className="small fw-bold text-muted text-uppercase">District</Form.Label>
                              <Form.Control readOnly value={TitleCase(ref1?.value?.city)} className="bg-white border-0 shadow-none" style={{ fontSize: '14px' }} />
                            </Form.Group>
                            <Form.Group as={Col} xs={12} md={3}>
                              <Form.Label className="small fw-bold text-muted text-uppercase">Mobile No.</Form.Label>
                              <Form.Control readOnly value={ref1?.value?.mobile || ''} className="bg-white border-0 shadow-none" style={{ fontSize: '14px' }} />
                            </Form.Group>
                          </Row>
                        </div>

                        {/* --- SECTION: BUYER DETAILS --- */}
                        <div className="mb-5">
                          <h6 className="text-uppercase fw-bold mb-3 d-flex align-items-center" style={{ color: '#198754', fontSize: '0.8rem' }}>
                            <span className="me-2">Buyer Details</span>
                            <hr className="flex-grow-1 my-0 opacity-10" />
                          </h6>
                          {buyer_Details.map((fields, index) => (
                            <div key={index} className="mb-3 p-3 border-start border-4 border-success rounded-end bg-light shadow-sm">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <span className="fw-bold small text-dark">Buyer #{index + 1} {fields.buyer_Detail?.cid && <span className="badge bg-success ms-2">{fields.buyer_Detail.cid}</span>}</span>
                                {buyer_Details.length > 1 && (
                                  <Button variant="link" className="text-danger p-0 text-decoration-none small" onClick={() => handleRemoveBuyer(index)}>
                                    <MdClose /> Remove
                                  </Button>
                                )}
                              </div>
                              <Row className="g-3">
                                <Form.Group as={Col} xs={12} md={3}>
                                  <Form.Label className="small fw-bold text-muted">NAME</Form.Label>
                                  <CreatableSelect
                                    onCreateOption={handleCreate_cus}
                                    isClearable
                                    value={fields.buyer_Detail.name ? { value: fields.buyer_Detail, label: fields.buyer_Detail?.name?.toUpperCase() } : null}
                                    options={options || []}
                                    onChange={(v, a) => handleChangeOptionBuy(index, v, a)}
                                    styles={selectStyles}
                                  />
                                </Form.Group>
                                <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">ADDRESS</Form.Label><Form.Control readOnly value={TitleCase(fields.buyer_Detail.address)} className="bg-white border-0" /></Form.Group>
                                <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">DISTRICT</Form.Label><Form.Control readOnly value={TitleCase(fields.buyer_Detail.city)} className="bg-white border-0" /></Form.Group>
                                <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">MOBILE</Form.Label><Form.Control readOnly value={fields.buyer_Detail.mobile || ''} className="bg-white border-0" /></Form.Group>
                              </Row>
                            </div>
                          ))}
                          <Button variant="outline-success" className="rounded-pill px-3 fw-bold" size="sm" onClick={handleAddBuyer}><MdAdd /> Add Another Buyer</Button>
                        </div>

                        {/* --- SECTION: SELLER DETAILS --- */}
                        <div className="mb-5">
                          <h6 className="text-uppercase fw-bold mb-3 d-flex align-items-center" style={{ color: '#fd7e14', fontSize: '0.8rem' }}>
                            <span className="me-2">Seller Details</span>
                            <hr className="flex-grow-1 my-0 opacity-10" />
                          </h6>
                          {seller_Details.map((fields, index) => (
                            <div key={index} className="mb-3 p-3 border-start border-4 border-warning rounded-end bg-light shadow-sm">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <span className="fw-bold small text-dark">Seller #{index + 1} {fields.seller_Detail?.cid && <span className="badge bg-warning text-dark ms-2">{fields.seller_Detail.cid}</span>}</span>
                                {seller_Details.length > 1 && (
                                  <Button variant="link" className="text-danger p-0 text-decoration-none small" onClick={() => handleRemoveSeller(index)}>
                                    <MdClose /> Remove
                                  </Button>
                                )}
                              </div>
                              <Row className="g-3">
                                <Form.Group as={Col} xs={12} md={3}>
                                  <Form.Label className="small fw-bold text-muted">NAME</Form.Label>
                                  <CreatableSelect
                                    onCreateOption={handleCreate_cus}
                                    isClearable
                                    value={fields.seller_Detail.name ? { value: fields.seller_Detail, label: fields.seller_Detail.name?.toUpperCase() } : null}
                                    options={options || []}
                                    onChange={(v, a) => handleChangeOptionSel(index, v, a)}
                                    styles={selectStyles}
                                  />
                                </Form.Group>
                                <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">ADDRESS</Form.Label><Form.Control readOnly value={TitleCase(fields.seller_Detail.address)} className="bg-white border-0" /></Form.Group>
                                <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">DISTRICT</Form.Label><Form.Control readOnly value={TitleCase(fields.seller_Detail.city)} className="bg-white border-0" /></Form.Group>
                                <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">MOBILE</Form.Label><Form.Control readOnly value={fields.seller_Detail.mobile || ''} className="bg-white border-0" /></Form.Group>
                              </Row>
                            </div>
                          ))}
                          <Button variant="outline-warning" className="rounded-pill px-3 fw-bold text-dark" size="sm" onClick={handleAddSeller}><MdAdd /> Add Another Seller</Button>
                        </div>

                        {/* --- SECTION: WITNESS DETAILS --- */}
                        <div>
                          <h6 className="text-uppercase fw-bold mb-3 d-flex align-items-center" style={{ color: '#0dcaf0', fontSize: '0.8rem' }}>
                            <span className="me-2">Witness Details</span>
                            <hr className="flex-grow-1 my-0 opacity-10" />
                          </h6>
                          <Row className="g-3">
                            {witness_Details.map((fields, index) => (
                              <Col xs={12} key={index}>
                                <div className="p-3 border rounded-3 bg-white shadow-sm border-info-subtle">
                                  <h6 className="small fw-bold text-info mb-3">Witness {index + 1} {fields.witness_Detail?.cid && <span className="badge bg-info text-dark ms-2">{fields.witness_Detail.cid}</span>}</h6>
                                  <Row className="g-3">
                                    <Form.Group as={Col} md={3}>
                                      <Form.Label className="small fw-bold text-muted">NAME</Form.Label>
                                      <CreatableSelect
                                        onCreateOption={handleCreate_cus}
                                        isClearable
                                        value={fields.witness_Detail.name ? { value: fields.witness_Detail, label: fields.witness_Detail.name?.toUpperCase() } : null}
                                        options={options || []}
                                        onChange={(v, a) => handleChangeOptionWit(index, v, a)}
                                        styles={selectStyles}
                                      />
                                    </Form.Group>
                                    <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">ADDRESS</Form.Label><Form.Control readOnly value={TitleCase(fields.witness_Detail.address)} className="bg-light border-0" /></Form.Group>
                                    <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">DISTRICT</Form.Label><Form.Control readOnly value={TitleCase(fields.witness_Detail.city)} className="bg-light border-0" /></Form.Group>
                                    <Form.Group as={Col} md={3}><Form.Label className="small fw-bold text-muted">MOBILE</Form.Label><Form.Control readOnly value={fields.witness_Detail.mobile || ''} className="bg-light border-0" /></Form.Group>
                                  </Row>
                                </div>
                              </Col>
                            ))}
                          </Row>
                        </div>
                      </Card.Body>
                    </Card>
                  </motion.div>
                )}

                {/* STEP 2: Land Details */}
                {currentStep === 2 && (
                  <motion.div key="st2" initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>
                    <Card className="shadow-sm border-0 rounded-3">
                      <Card.Body className="p-4">
                        <h5 className="fw-bold mb-4 d-flex align-items-center" style={{ color: "#4a127e" }}>
                          Document Details
                        </h5>
                        
                        {/* --- SECTION 1: LOCATION --- */}
                        <div className="mb-4">
                          <Row className="g-3">
                            <Col md={4}>
                              <Form.Label className="small fw-bold text-secondary">VILLAGE</Form.Label>
                              <Form.Select 
                                className="shadow-none border-secondary-subtle"
                                value={formData.villageId} 
                                disabled={!formData.officeId} 
                                onChange={(e) => { 
                                  setFormData({...formData, villageId: e.target.value}); 
                                  set_vill(formVillages.find(v => v.id === e.target.value)?.villageName || ""); 
                                }}
                              >
                                <option value="">Choose Village...</option>
                                {formVillages.slice().sort((a, b) => (a.villageName || "").localeCompare(b.villageName || "")).map(v => (<option key={v.id} value={v.id}>{v.villageName.toUpperCase()}</option>))}
                              </Form.Select>
                            </Col>
                            <Col md={4}>
                              <Form.Label className="small fw-bold text-secondary">LAYOUT NAME</Form.Label>
                              <CreatableSelect
                                isClearable
                                isDisabled={!formData.villageId}
                                options={layoutOptions}
                                value={selectedLayout}
                                placeholder="Choose Layout..."
                                onChange={(selectedOption) => {
                                  // Handles standard selection and clearing (when selectedOption is null)
                                  setFormData({ 
                                    ...formData, 
                                    layoutId: selectedOption ? selectedOption.value : "" 
                                  });
                                  set_Layout(selectedOption ? selectedOption.label : "");
                                }}
                                onCreateOption={(inputValue) => handleAddLayout(inputValue)}
                                
                                // Basic styling to match Bootstrap inputs
                                styles={{
                                  control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? '#86b7fe' : '#dee2e6',
                                    boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : 'none',
                                    '&:hover': { borderColor: state.isFocused ? '#86b7fe' : '#dee2e6' },
                                  })
                                }}
                              />
                            </Col>
                            <Col md={2}>
                              <Form.Label className="small fw-bold text-secondary">S.F NO.</Form.Label>
                              <Form.Control 
                                className="shadow-none" 
                                name='sfno' 
                                type='text' 
                                placeholder='SF No.'
                                isInvalid={currentStep === 2 && !individual.sfno}
                                value={individual.sfno || ''}
                                onChange={(e) => {
                                  const { value } = e.target;
                                  const regex = /^[A-Za-z0-9/\-,\s ]*$/;
                                  if (regex.test(value)) {
                                    handleIndividualChange(e);
                                  }
                                }}
                              />
                              {/* Feedback shows only when isInvalid is true */}
                              <Form.Control.Feedback type="invalid">
                                Survey Number is required.
                              </Form.Control.Feedback>
                            </Col>

                            <Col md={2}>
                              <Form.Label className="small fw-bold text-secondary">SITE NO.</Form.Label>
                              <Form.Control 
                                className="shadow-none" 
                                name='siteno' 
                                type='text' 
                                placeholder='Site No.' 
                                // Trigger red border if Step 2 is active but field is empty
                                isInvalid={currentStep === 2 && !individual.siteno}
                                value={individual.siteno || ''}
                                onChange={(e) => {
                                  const { value } = e.target;
                                  const regex = /^[A-Za-z0-9/\-,\s ]*$/;
                                  if (regex.test(value)) {
                                    handleIndividualChange(e);
                                  }
                                }}
                              />
                              {/* This will now show when isInvalid is true */}
                              <Form.Control.Feedback type="invalid">
                                Site Number is required (A-Z, 0-9, / - , .)
                              </Form.Control.Feedback>
                            </Col>
                          </Row>
                        </div>

                        {/* --- SECTION 2: PARENT DOCUMENTS --- */}
                        <div className="mb-5">
                        <h6 className="text-uppercase fw-bold mb-3 d-flex align-items-center" style={{ color: '#0d6efd', fontSize: '0.8rem' }}>
                          <span className="me-2">Parent Document Details</span>
                          <hr className="flex-grow-1 my-0 opacity-10" />
                        </h6>

                        {parent_document.map((doc, index) => (
                          <div key={index} className="mb-3 p-3 border-start border-4 border-primary rounded-end bg-white shadow-sm">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <span className="fw-bold small text-dark">Document #{index + 1}</span>
                              {parent_document.length > 1 && (
                                <Button variant="link" className="text-danger p-0 text-decoration-none small" onClick={() => handleRemoveparent_Document(index)}>
                                  <MdClose /> Remove
                                </Button>
                              )}
                            </div>
                            <Row className="g-3">
                              <Col md={6}>
                                <Form.Label className="small fw-bold text-muted">DOCUMENT TYPE</Form.Label>
                                <CreatableSelect
                                  isClearable
                                  value={doc.type ? { value: doc.type, label: doc.type } : null}
                                  options={options_doc || []}
                                  placeholder="Select Type..."
                                  onCreateOption={handleCreate_doc}
                                  onChange={(val) => handleChangeparent_Documenttype(index, val)}
                                  styles={selectStyles}
                                />
                              </Col>
                              <Col md={6}>
                                <Form.Label className="small fw-bold text-muted">DOCUMENT NUMBER</Form.Label>
                                <Form.Control
                                  value={doc.number}
                                  onChange={(e) => handleChangeparent_Documentnumber(index, e.target.value)}
                                  placeholder="Enter Number"
                                />
                              </Col>
                            </Row>
                          </div>
                        ))}
                        <Button variant="outline-primary" className="rounded-pill px-3 fw-bold" size="sm" onClick={handleAddparent_Document}>
                          <MdAdd /> Add New Document
                        </Button>
                      </div>

                        {/* --- SECTION 3: QUOTATION & SPLIT --- */}
                        <div className="pt-3 border-top">
                          <Row className="g-4 align-items-center">
                            <Col md={6}>
                              <Form.Group>
                                <Form.Label className="small fw-bold text-secondary text-uppercase">
                                  Approximate Quotation (₹)
                                </Form.Label>
                                <div className="input-group">
                                  <span className="input-group-text bg-white border-end-0 text-muted">₹</span>
                                  <Form.Control 
                                    className="shadow-none border-start-0"
                                    name='approximate_quatation' 
                                    type='text' // Changed to text to better control filtering
                                    inputMode='numeric' // Opens number pad on mobile
                                    placeholder='0'
                                    isInvalid={currentStep === 2 && !individual.approximate_quatation}
                                    value={individual.approximate_quatation || ''}
                                    onChange={(e) => {
                                      const { value } = e.target;
                                      // Allows only digits 0-9
                                      const regex = /^[0-9]*$/;
                                      if (regex.test(value)) {
                                        handleIndividualChange(e);
                                      }
                                    }}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    Please enter a valid amount.
                                  </Form.Control.Feedback>
                                </div>
                              </Form.Group>
                            </Col>

                            <Col md={6}>
                              <Form.Label className="small fw-bold text-secondary text-uppercase d-block mb-2">
                                Split Required?
                              </Form.Label>
                              <div className="d-flex align-items-center p-2 rounded-3 border bg-light" style={{ width: 'fit-content' }}>
                                <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                  <Typography sx={{ fontSize: '12px', color: individual.document_Split === 'no' ? '#28a745' : '#adb5bd', fontWeight: 700 }}>
                                    COPY
                                  </Typography>
                                  
                                  <AntSwitch 
                                    checked={individual.document_Split === 'yes'} 
                                    onChange={(e) => set_Individual({ 
                                      ...individual, 
                                      document_Split: e.target.checked ? 'yes' : 'no' 
                                    })} 
                                  />
                                  
                                  <Typography sx={{ fontSize: '12px', color: individual.document_Split === 'yes' ? '#8a2be2' : '#adb5bd', fontWeight: 700 }}>
                                    SPLIT
                                  </Typography>
                                </Stack>
                              </div>
                            </Col>
                          </Row>
                        </div>

                      </Card.Body>
                    </Card>
                  </motion.div>
                )}

                {/* STEP 3: Guideline */}
                {currentStep === 3 && (
                  <motion.div key="st3" initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>
                    <Card className="shadow-sm border-0 rounded-3 overflow-hidden">
                      <Card.Header className="bg-white border-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                        <div>
                          <h5 className="fw-bold mb-0" style={{ color: "#4a127e" }}>Guideline Value</h5>
                          <p className="text-muted small mb-0">Verify the current market/government value.</p>
                        </div>
                        
                        {/* ONLINE / OFFLINE TOGGLE */}
                        <div className="p-2 rounded-pill border bg-light d-flex align-items-center px-3">
                          <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                            <Typography sx={{ fontSize: '12px', color: status === 'offline' ? '#e7ac2d' : '#adb5bd', fontWeight: 700, textTransform: 'uppercase' }}>Offline</Typography>
                            <AntSwitch 
                              checked={status === 'online'} 
                              onChange={(e) => setStatus(e.target.checked ? 'online' : 'offline')} 
                            />
                            <Typography sx={{ fontSize: '12px', color: status === 'online' ? '#8a2be2' : '#adb5bd', fontWeight: 700, textTransform: 'uppercase' }}>Online</Typography>
                          </Stack>
                        </div>
                      </Card.Header>

                      <Card.Body className="text-center py-5 px-4">
                        <div className="mb-4">
                          <Form.Label className="fw-bold d-block h6" style={{ color: '#555' }}>
                            Has Guideline Value been checked?
                          </Form.Label>
                        </div>
                        
                        <div className="d-flex flex-column align-items-center gap-3">
                          {/* THREE STATE TOGGLE */}
                          <div className="p-3 rounded-4 bg-light border border-dashed">
                            <ThreeStateToggle 
                              value={edit.value_check.values} 
                              onChange={(val) => set_Edit({
                                ...edit, 
                                value_check: { ...edit.value_check, values: val }
                              })} 
                              disabled={!canToggle('value_check')}
                            />
                          </div>

                          <span className="d-inline-flex overflow-hidden align-items-center" style={{ height: '18px' }}>
    <AnimatePresence mode="wait">
        <motion.span
            key={edit.value_check.values || 'pending'} /* Triggers animation, uses fallback for null */
            initial={{ y: 15, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -15, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="fw-bold text-uppercase" 
            style={{ 
                fontSize: '12px', 
                letterSpacing: '1px',
                color: edit.value_check.values === 'yes' ? '#28a745' : (edit.value_check.values === 'no' ? '#dc3545' : '#adb5bd') 
            }}
        >
            {edit.value_check.values === 'yes' ? '● Verified' : edit.value_check.values === 'no' ? '● Not Verified' : '● Pending Action'}
        </motion.span>
    </AnimatePresence>
</span>

                          {/* CONDITIONAL INPUT */}
                          <AnimatePresence>
                            {status === 'online' && edit.value_check.values === 'yes' && (
                              <motion.div 
                                initial={{ opacity: 0, scale: 0.9 }} 
                                animate={{ opacity: 1, scale: 1 }} 
                                exit={{ opacity: 0, scale: 0.9 }}
                                className="w-100 mt-4"
                              >
                                <Form.Group className="mx-auto p-4 rounded-3 border-start border-4 border-success bg-white shadow-sm" style={{ maxWidth: '400px' }}>
                                  <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">Confirm Guideline Value (₹)</Form.Label>
                                  <div className="input-group input-group-lg">
                                    <span className="input-group-text bg-white text-muted border-end-0">₹</span>
                                    <Form.Control 
                                      type="text" 
                                      inputMode="numeric" // Forces numeric keypad on mobile devices
                                      placeholder="0" 
                                      value={edit.value_check.doc_value || ''}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        // Regex allows only digits (0-9). Use /^\d*\.?\d*$/ if you need decimals.
                                        if (/^\d*$/.test(val)) {
                                          set_Edit({
                                            ...edit, 
                                            value_check: { ...edit.value_check, doc_value: val }
                                          });
                                        }
                                      }}
                                      // isInvalid logic helps the user see why Stage 3 isn't completing
                                      isInvalid={status === 'online' && edit.value_check.values === 'yes' && !edit.value_check.doc_value}
                                      className="text-center fw-bold border-start-0 shadow-none"
                                      style={{ border: '1px solid #dee2e6' }}
                                    />
                                  </div>
                                  <small className="text-muted mt-2 d-block">Required for online processing</small>
                                </Form.Group>
                              </motion.div>
                            )}
                          </AnimatePresence>
                          <AnimatePresence>
                            {status === 'online' && 
                            edit.value_check.values === 'yes' && 
                            !!edit.value_check.doc_value?.toString().trim() && (
                              <motion.div 
                                initial={{ opacity: 0, y: 10 }} 
                                animate={{ opacity: 1, y: 0 }} 
                                exit={{ opacity: 0, y: 10 }}
                                className="w-100"
                                style={{ maxWidth: '400px' }}
                              >
                                <Button 
                                  variant="primary"
                                  size="sm" 
                                  className="w-100 fw-bold py-2 rounded-pill shadow-sm mt-3"
                                  onClick={() => handleMsg('GV', { 
                                    app_no: app_No, 
                                    gv: edit.value_check.doc_value 
                                  })}
                                  style={{ 
                                    backgroundColor: '#8a2be2', 
                                    border: 'none', 
                                    fontSize: '13px',
                                    letterSpacing: '0.5px' 
                                  }}
                                >
                                  GUIDELINE VALUE MASSAGE
                                </Button>
                              </motion.div>
                            )}
                          </AnimatePresence>
                        </div>
                      </Card.Body>
                    </Card>
                  </motion.div>
                )}

                {/* STEP 4: Drafting (draft_prepared, draft_send, draft_approved) */}
                {currentStep === 4 && (
                  <motion.div key="st4" initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>
                    <Card className="shadow-sm border-0 rounded-3">
                      <Card.Header className="bg-white border-0 pt-4 px-4">
                        <h5 className="fw-bold mb-0" style={{ color: "#4a127e" }}>Offline Draft</h5>
                        <p className="text-muted small">Track the preparation, delivery, and approval of the draft.</p>
                      </Card.Header>
                      
                      <Card.Body className="px-4 pb-5">
                        <Row className="g-4">
                          
                          {/* --- STAGE 1: PREPARATION --- */}
                          <Col md={4}>
                            <div className={`p-3 rounded-3 border h-100 ${edit.draft_prepared.values === 'yes' ? 'bg-light border-success-subtle' : 'bg-white'}`}>
                              <Form.Group>
                                <Form.Label className="small fw-bold text-muted text-uppercase mb-3 d-block">1. Draft Prepared</Form.Label>
                                <ThreeStateToggle 
                                  value={edit.draft_prepared.values} 
                                  onChange={(val) => set_Edit({...edit, draft_prepared: {...edit.draft_prepared, values: val}})} 
                                  disabled={!canToggle('draft_prepared')}
                                />
                                <div className="mt-2 text-center overflow-hidden" style={{ height: '24px' }}>
    <AnimatePresence mode="wait">
        <motion.div
            key={edit.draft_prepared.values || 'pending'} /* Triggers the animation when this value changes */
            initial={{ y: 15, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -15, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
        >
            <small className={`fw-bold ${edit.draft_prepared.values === 'yes' ? 'text-success' : edit.draft_prepared.values === 'no' ? 'text-danger' : 'text-muted'}`}>
                {edit.draft_prepared.values === 'yes' ? 'Ready for Sending' : edit.draft_prepared.values === 'no' ? 'Declined' : 'Awaiting Preparation'}
            </small>
        </motion.div>
    </AnimatePresence>
</div>
                              </Form.Group>
                            </div>
                          </Col>

                          {/* --- STAGE 2: DELIVERY --- */}
                          <Col md={4}>
                            <div className={`p-3 rounded-3 border h-100 ${edit.draft_send.values === 'yes' ? 'bg-light border-primary-subtle' : 'bg-white'}`}>
                              <Form.Group>
                                <Form.Label className="small fw-bold text-muted text-uppercase mb-3 d-block">2. Draft Sent</Form.Label>
                                <ThreeStateToggle 
                                  value={edit.draft_send.values} 
                                  onChange={(val) => set_Edit({...edit, draft_send: {...edit.draft_send, values: val}})} 
                                  disabled={!canToggle('draft_send')}
                                />

                                <AnimatePresence>
                                  {edit.draft_send.values === 'yes' && (
                                    <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="mt-3 overflow-hidden">
                                      
                                      <Form.Label className="small fw-bold text-secondary mb-1">THROUGH</Form.Label>
                                      <Select 
                                        placeholder="Select"
                                        options={option_through}
                                        styles={selectStyles}
                                        menuPortalTarget={document.body} 
                                        menuPosition="fixed" 
                                        value={edit?.draft_send?.through 
                                          ? { value: edit.draft_send.through, label: TitleCase(edit.draft_send.through) } 
                                          : null 
                                        }
                                        onChange={(selected) => set_Edit({
                                          ...edit,
                                          draft_send: {
                                            ...edit.draft_send,
                                            through: selected ? selected.value : "" 
                                          }
                                        })}
                                      />

                                      {/* --- NEW FILE UPLOAD FIELD (ONLY SHOWS IF 'ONLINE' IS SELECTED) --- */}
                                      {edit?.draft_send?.through === 'online' && (
                                        <div className="mt-3">
                                          <Form.Label className="small fw-bold text-secondary mb-1">UPLOAD DRAFT (PDF, Max 5MB)</Form.Label>
                                          
                                          {/* 1. SHOW INPUT ONLY IF NO FILE EXISTS */}
                                          {!(edit.draft_send.file || edit.draft_send.fileData?.url) ? (
                                            <Form.Control 
                                              type="file" 
                                              accept="application/pdf"
                                              size="sm"
                                              onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                  // Check if file is a PDF
                                                  if (file.type !== 'application/pdf') {
                                                    alert('Only PDF files are allowed.');
                                                    e.target.value = null; // Reset the input
                                                    return;
                                                  }
                                                  // Check if file is under 5 MB (5 * 1024 * 1024 bytes)
                                                  if (file.size > 5 * 1024 * 1024) {
                                                    alert('File size must be under 5 MB.');
                                                    e.target.value = null; // Reset the input
                                                    return;
                                                  }
                                                  
                                                  // If valid, save to state
                                                  set_Edit({
                                                    ...edit,
                                                    draft_send: {
                                                      ...edit.draft_send,
                                                      file: file 
                                                    }
                                                  });
                                                }
                                              }}
                                            />
                                          ) : (
                                            /* 2. SHOW VIEW & REMOVE BUTTONS IF FILE EXISTS */
                                            <div className="d-flex justify-content-between align-items-center p-2 border rounded bg-light mt-1">
                                              <span className="small text-truncate text-muted fw-bold me-2">
                                                <i className="bi bi-file-earmark-pdf-fill text-danger me-2"></i>
                                                {edit.draft_send.file ? edit.draft_send.file.name : 'Draft_Document.pdf'}
                                              </span>
                                              <div className="d-flex gap-2">
                                                <Button 
                                                  variant="outline-primary" 
                                                  size="sm" 
                                                  className="fw-bold shadow-sm rounded-pill px-3"
                                                  onClick={() => {
                                                    // Generate a local URL for the selected file or use DB URL
                                                    const url = edit.draft_send.file ? URL.createObjectURL(edit.draft_send.file) : edit.draft_send.fileData?.url;
                                                    if (url) window.open(url, '_blank');
                                                  }}
                                                >
                                                  <i className="bi bi-eye me-1"></i> VIEW
                                                </Button>
                                                <Button 
                                                  variant="outline-danger" 
                                                  size="sm" 
                                                  className="fw-bold shadow-sm rounded-pill px-3"
                                                  onClick={() => {
                                                    // Completely remove the file from state to bring the input back
                                                    set_Edit({
                                                      ...edit,
                                                      draft_send: {
                                                        ...edit.draft_send,
                                                        file: null,
                                                        fileData: null // Clears DB data as well if applicable
                                                      }
                                                    });
                                                  }}
                                                >
                                                  <i className="bi bi-trash me-1"></i> REMOVE
                                                </Button>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      )}
                                      
                                    </motion.div>
                                  )}
                                </AnimatePresence>
                              </Form.Group>
                            </div>
                          </Col>

                          {/* --- STAGE 3: APPROVAL --- */}
                          <Col md={4}>
                            <div className={`p-3 rounded-3 border h-100 ${edit.draft_approved.values === 'yes' ? 'bg-light border-warning-subtle' : 'bg-white'}`}>
                              <Form.Group>
                                <Form.Label className="small fw-bold text-muted text-uppercase mb-3 d-block">3. Draft Approved</Form.Label>
                                <ThreeStateToggle 
                                  value={edit.draft_approved.values} 
                                  onChange={(val) => set_Edit({...edit, draft_approved: {...edit.draft_approved, values: val}})} 
                                  disabled={!canToggle('draft_approved')}
                                />

                                <AnimatePresence>
                                  {edit.draft_approved.values === 'yes' && (
                                    <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="mt-3 overflow-hidden">
                                      <Form.Label className="small fw-bold text-secondary mb-1">APPROVED BY</Form.Label>
                                      <Form.Control
                                        className="shadow-none border-0 bg-white"
                                        placeholder="Enter Name"
                                        value={TitleCase(edit.draft_approved.by)}
                                        disabled={user.role === "user" && edit.draft_approved.clicked > 0}
                                        onChange={(e) => set_Edit({...edit, draft_approved: {...edit.draft_approved, by: e.target.value}})} 
                                        isInvalid={!edit.draft_approved.by}
                                      />
                                      <Form.Control.Feedback type="invalid" style={{fontSize: '10px'}}>Required field</Form.Control.Feedback>
                                    </motion.div>
                                  )}
                                </AnimatePresence>
                              </Form.Group>
                            </div>
                          </Col>

                        </Row>
                      </Card.Body>
                    </Card>
                  </motion.div>
                )}

                {/* STEP 5: EC (ec_applied, ec_received) */}
                {currentStep === 5 && (
                  <motion.div key="st5" initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>
                    <Card className="shadow-sm border-0 rounded-3 overflow-hidden">
                      <Card.Header className="bg-white border-0 pt-4 px-4 d-flex justify-content-between align-items-center flex-wrap gap-3">
                        <div>
                          <h5 className="fw-bold mb-0" style={{ color: "var(--brand-purple)" }}>
                            Encumbrance Certificate Process
                          </h5>
                          <p className="text-muted small mb-0">Monitor the application and receipt of the Encumbrance Certificate.</p>
                        </div>
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <span className="small fw-bold text-muted text-uppercase" style={{ fontSize: '0.75rem' }}>
                            Already Applied EC?
                          </span>
                          <div className="p-2 rounded-pill border bg-light d-flex align-items-center px-3 shadow-sm">
                            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                              <Typography sx={{ fontSize: '11px', color: alreadyAppliedEc === 'no' ? '#e7ac2d' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>No</Typography>
                              <AntSwitch
                                checked={alreadyAppliedEc === 'yes'}
                                onChange={(e) => {
                                  const next = e.target.checked ? 'yes' : 'no';
                                  setAlreadyAppliedEc(next);
                                  if (next === 'yes') {
                                    setLinkedEc(null);
                                    set_Edit({
                                      ...edit,
                                      certificate_applied: { ...edit.certificate_applied, values: null, eca_no: "" },
                                    });
                                  } else {
                                    setLinkedEc(null);
                                  }
                                }}
                              />
                              <Typography sx={{ fontSize: '11px', color: alreadyAppliedEc === 'yes' ? '#8a2be2' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>Yes</Typography>
                            </Stack>
                          </div>
                        </div>
                      </Card.Header>
                      
                      <Card.Body className="px-4 pb-5">
                        {alreadyAppliedEc === 'yes' ? (
                          <Row className="g-4">
                            <Col xs={12} md={6}>
                              <Form.Group className="p-4 rounded-3 border h-100 bg-white">
                                <Form.Label className="small fw-bold text-muted text-uppercase mb-3 d-block">
                                  1. Select EC from My EC <span className="text-danger">*</span>
                                </Form.Label>
                                <Select
                                  isClearable
                                  options={(ecs || [])
                                    .filter((d) => d.docstatus !== "processing")
                                    .slice()
                                    .sort((a, b) => (a.application_no || "").localeCompare(b.application_no || ""))
                                    .map((ec) => ({
                                      value: ec.id,
                                      label: `${(ec.application_no || "N/A").toUpperCase()} — ${(ec.owner?.name || "N/A").toUpperCase()}`,
                                      ec,
                                    }))}
                                  value={linkedEc}
                                  onChange={setLinkedEc}
                                  placeholder="Search application no. or owner..."
                                  styles={selectStyles}
                                  menuPortalTarget={document.body}
                                />
                                {!linkedEc && (
                                  <small className="text-danger d-block mt-2">Please select an EC application.</small>
                                )}
                              </Form.Group>
                            </Col>

                            {/* --- EC RECEIVED (also for Already Applied Yes) --- */}
                            <Col xs={12} md={6}>
                              <div className={`p-4 rounded-3 border h-100 ${edit.certificate_received.values === 'yes' ? 'bg-light border-success-subtle' : 'bg-white'}`}>
                                <Form.Group>
                                  <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                    2. Certificate Received
                                  </Form.Label>
                                  
                                  <div className="mb-3">
                                    <ThreeStateToggle 
                                      value={edit.certificate_received.values} 
                                      onChange={(val) => set_Edit({...edit, certificate_received: {...edit.certificate_received, values: val}})} 
                                      disabled={!canToggle('certificate_received')}
                                    />
                                  </div>

                                  <AnimatePresence>
                                    {edit.certificate_received.values === 'yes' && (
                                      <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }}>
                                        <div className="alert alert-success border-0 small py-2 text-center fw-bold">
                                          Encumbrance Certificate Application Complete
                                        </div>

                                        <div className="mb-3 text-start">
                                          <Form.Label className="small fw-bold text-secondary mb-1">UPLOAD CERTIFICATE (PDF, Max 5MB)</Form.Label>
                                          {!(edit?.certificate_received?.file || edit?.certificate_received?.fileData?.url) ? (
                                            <Form.Control 
                                              type="file" 
                                              accept="application/pdf"
                                              size="sm"
                                              onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                  if (file.type !== 'application/pdf') {
                                                    alert('Only PDF files are allowed.');
                                                    e.target.value = null;
                                                    return;
                                                  }
                                                  if (file.size > 5 * 1024 * 1024) {
                                                    alert('File size must be under 5 MB.');
                                                    e.target.value = null;
                                                    return;
                                                  }
                                                  set_Edit({
                                                    ...edit,
                                                    certificate_received: {
                                                      ...edit.certificate_received,
                                                      file: file 
                                                    }
                                                  });
                                                }
                                              }}
                                            />
                                          ) : (
                                            <div className="d-flex justify-content-between align-items-center p-2 border rounded bg-light mt-1">
                                              <span className="small text-truncate text-muted fw-bold me-2">
                                                <i className="bi bi-file-earmark-pdf-fill text-danger me-2"></i>
                                                {edit.certificate_received.file ? edit.certificate_received.file.name : 'EC_Certificate.pdf'}
                                              </span>
                                              <div className="d-flex gap-2">
                                                <Button 
                                                  variant="outline-primary" 
                                                  size="sm" 
                                                  className="fw-bold shadow-sm rounded-pill px-3"
                                                  onClick={() => {
                                                    const url = edit.certificate_received.file ? URL.createObjectURL(edit.certificate_received.file) : edit.certificate_received.fileData?.url;
                                                    if (url) window.open(url, '_blank');
                                                  }}
                                                >
                                                  <i className="bi bi-eye me-1"></i> VIEW
                                                </Button>
                                                <Button 
                                                  variant="outline-danger" 
                                                  size="sm" 
                                                  className="fw-bold shadow-sm rounded-pill px-3"
                                                  onClick={() => {
                                                    set_Edit({
                                                      ...edit,
                                                      certificate_received: {
                                                        ...edit.certificate_received,
                                                        file: null,
                                                        fileData: null
                                                      }
                                                    });
                                                  }}
                                                >
                                                  <i className="bi bi-trash me-1"></i> REMOVE
                                                </Button>
                                              </div>
                                            </div>
                                          )}
                                        </div>

                                        <Button 
                                          variant="success"
                                          size="sm" 
                                          className="w-100 py-2 fw-bold shadow-sm rounded-pill" 
                                          onClick={() => handleMsg('EC', { 
                                            app_no: app_No, 
                                            ec_no: linkedEc?.ec?.application_no
                                              ? String(linkedEc.ec.application_no).toUpperCase()
                                              : `ECA/Online/${edit.certificate_applied?.eca_no}/${new Date().getFullYear()}` 
                                          })}
                                        >
                                          <i className="bi bi-send-check me-2"></i>EC RECEIVED MESSAGE
                                        </Button>
                                      </motion.div>
                                    )}
                                  </AnimatePresence>
                                </Form.Group>
                              </div>
                            </Col>
                          </Row>
                        ) : (
                        <Row className="g-4">
                          
                          {/* --- EC APPLICATION APPLIED --- */}
                          <Col xs={12} md={6}>
                            <div className={`p-4 rounded-3 border h-100 ${edit.certificate_applied.values === 'yes' ? 'bg-light border-primary-subtle' : 'bg-white'}`}>
                              <Form.Group>
                                <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                  1. Encumbrance Certificate Application {status === "online" && "(Online)"}
                                </Form.Label>
                                
                                <div className="mb-3">
                                  <ThreeStateToggle 
                                    value={edit.certificate_applied.values} 
                                    onChange={(val) => set_Edit({...edit, certificate_applied: {...edit.certificate_applied, values: val}})} 
                                    disabled={!canToggle('certificate_applied')}
                                  />
                                </div>
                                
                                <AnimatePresence>
                                  {edit.certificate_applied.values === 'yes' && (
                                    <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}>
                                      <Form.Label className="small fw-bold text-secondary text-uppercase mb-1">
                                        Encumbrance Certificate Application No. <span className="text-danger">*</span>
                                      </Form.Label>
                                      <Form.Control 
                                        className="shadow-none border-secondary-subtle fw-bold" 
                                        value={edit.certificate_applied.eca_no || ''} 
                                        // Forces numeric keypad on mobile devices
                                        inputMode="numeric"
                                        // Using type="text" with regex provides better control than type="number"
                                        type="text"
                                        placeholder="Ex: 85942" 
                                        // Highlights red if the value is empty
                                        isInvalid={!edit.certificate_applied.eca_no}
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          // Regex allows only digits 0-9
                                          if (/^\d*$/.test(val)) {
                                            set_Edit({
                                              ...edit, 
                                              certificate_applied: {
                                                ...edit.certificate_applied, 
                                                eca_no: val
                                              }
                                            });
                                          }
                                        }}
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        ECA Number is required (Digits only).
                                      </Form.Control.Feedback>
                                    </motion.div>
                                  )}
                                </AnimatePresence>
                              </Form.Group>
                            </div>
                          </Col>

                          {/* --- EC RECEIVED --- */}
                          <Col xs={12} md={6}>
                            <div className={`p-4 rounded-3 border h-100 ${edit.certificate_received.values === 'yes' ? 'bg-light border-success-subtle' : 'bg-white'}`}>
                              <Form.Group>
                                <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                  2. Certificate Received
                                </Form.Label>
                                
                                <div className="mb-3">
                                  <ThreeStateToggle 
                                    value={edit.certificate_received.values} 
                                    onChange={(val) => set_Edit({...edit, certificate_received: {...edit.certificate_received, values: val}})} 
                                    disabled={!canToggle('certificate_received')}
                                  />
                                </div>

                                <AnimatePresence>
                                  {edit.certificate_received.values === 'yes' && (
                                    <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }}>
                                      <div className="alert alert-success border-0 small py-2 text-center fw-bold">
                                        Encumbrance Certificate Application Complete
                                      </div>

                                      {/* --- NEW FILE UPLOAD FIELD --- */}
                                      <div className="mb-3 text-start">
  <Form.Label className="small fw-bold text-secondary mb-1">UPLOAD CERTIFICATE (PDF, Max 5MB)</Form.Label>
  
  {/* 1. SHOW INPUT ONLY IF NO FILE EXISTS */}
  {!(edit?.certificate_received?.file || edit?.certificate_received?.fileData?.url) ? (
    <Form.Control 
      type="file" 
      accept="application/pdf"
      size="sm"
      onChange={(e) => {
        const file = e.target.files[0];
        if (file) {
          // Check if file is a PDF
          if (file.type !== 'application/pdf') {
            alert('Only PDF files are allowed.');
            e.target.value = null; // Reset the input
            return;
          }
          // Check if file is under 5 MB (5 * 1024 * 1024 bytes)
          if (file.size > 5 * 1024 * 1024) {
            alert('File size must be under 5 MB.');
            e.target.value = null; // Reset the input
            return;
          }
          
          // If valid, save to state
          set_Edit({
            ...edit,
            certificate_received: {
              ...edit.certificate_received,
              file: file 
            }
          });
        }
      }}
    />
  ) : (
    /* 2. SHOW VIEW & REMOVE BUTTONS IF FILE EXISTS */
    <div className="d-flex justify-content-between align-items-center p-2 border rounded bg-light mt-1">
      <span className="small text-truncate text-muted fw-bold me-2">
        <i className="bi bi-file-earmark-pdf-fill text-danger me-2"></i>
        {edit.certificate_received.file ? edit.certificate_received.file.name : 'EC_Certificate.pdf'}
      </span>
      <div className="d-flex gap-2">
        <Button 
          variant="outline-primary" 
          size="sm" 
          className="fw-bold shadow-sm rounded-pill px-3"
          onClick={() => {
            // Generate a local URL for the selected file or use DB URL
            const url = edit.certificate_received.file ? URL.createObjectURL(edit.certificate_received.file) : edit.certificate_received.fileData?.url;
            if (url) window.open(url, '_blank');
          }}
        >
          <i className="bi bi-eye me-1"></i> VIEW
        </Button>
        <Button 
          variant="outline-danger" 
          size="sm" 
          className="fw-bold shadow-sm rounded-pill px-3"
          onClick={() => {
            // Completely remove the file from state to bring the input back
            set_Edit({
              ...edit,
              certificate_received: {
                ...edit.certificate_received,
                file: null,
                fileData: null // Clears DB data as well if applicable
              }
            });
          }}
        >
          <i className="bi bi-trash me-1"></i> REMOVE
        </Button>
      </div>
    </div>
  )}
</div>

                                      <Button 
                                        variant="success"
                                        size="sm" 
                                        className="w-100 py-2 fw-bold shadow-sm rounded-pill" 
                                        onClick={() => handleMsg('EC', { 
                                          app_no: app_No, 
                                          ec_no: `ECA/Online/${edit.certificate_applied?.eca_no}/${new Date().getFullYear()}` 
                                        })}
                                      >
                                        <i className="bi bi-send-check me-2"></i>EC RECEIVED MESSAGE
                                      </Button>
                                    </motion.div>
                                  )}
                                </AnimatePresence>
                              </Form.Group>
                            </div>
                          </Col>

                        </Row>
                        )}
                      </Card.Body>
                    </Card>
                  </motion.div>
                )}

                {currentStep === 6 && (
                  <motion.div key="st6" initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>
                    <Card className="shadow-sm border-0 rounded-3">
                      <Card.Header className="bg-white border-0 pt-4 px-4">
                        <h5 className="fw-bold mb-0" style={{ color: "var(--brand-purple)" }}>
                          Online Draft
                        </h5>
                        <p className="text-muted small">Generate the Temporary Deed (TP) and schedule the registration token.</p>
                      </Card.Header>
                      
                      <Card.Body className="px-4 pb-5">
                        <Row className="g-4">
                          
                          {/* --- TEMPORARY DEED NO --- */}
                          <Col xs={12} md={status === 'online' ? 12 : 5}>
                            <div className={`p-4 rounded-3 border h-100 ${edit.deed_no.values === 'yes' ? 'bg-light border-primary-subtle' : 'bg-white'}`}>
                              <Form.Group>
                                <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">1. Temporary Deed (TP)</Form.Label>
                                <ThreeStateToggle 
                                  value={edit.deed_no.values} 
                                  onChange={(val) => set_Edit({...edit, deed_no: {...edit.deed_no, values: val}})} 
                                  disabled={!canToggle('deed_no')}
                                />

                                <AnimatePresence>
                                  {edit.deed_no.values === 'yes' && (
                                    <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="mt-3">
                                      <Form.Label className="small fw-bold text-secondary mb-1 text-uppercase">TP Number</Form.Label>
                                      <Form.Control 
                                        // Changed to text to support /, "", commas, and spaces
                                        type="text"
                                        className="shadow-none fw-bold"
                                        placeholder="Enter TP No. (Ex: 123/2026, 'A')"
                                        value={edit.deed_no.tp_no || ''}
                                        disabled={user.role === "user" && edit.deed_no.clicked > 0}
                                        // Validation feedback for Stage 6 logic
                                        isInvalid={currentStep === 6 && edit.deed_no.values === 'yes' && !edit.deed_no.tp_no}
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          // Regex allows A-Z, a-z, 0-9, spaces, and / , " ' - .
                                          const regex = /^[A-Za-z0-9/\-,\s"' ]*$/;
                                          
                                          if (regex.test(val)) {
                                            set_Edit({
                                              ...edit, 
                                              deed_no: { ...edit.deed_no, tp_no: val }
                                            });
                                          }
                                        }}
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        TP Number is required.
                                      </Form.Control.Feedback>
                                    </motion.div>
                                  )}
                                </AnimatePresence>
                              </Form.Group>
                            </div>
                          </Col>

                          {/* --- TOKEN INITIATED (hidden when Presenceless = Online) --- */}
                          {status !== 'online' && (
                          <Col xs={12} md={7}>
                            <div className={`p-4 rounded-3 border h-100 ${edit.token_initiated.values === 'yes' ? 'bg-light border-warning-subtle' : 'bg-white'}`}>
                              <Form.Group>
                                <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">2. Token Initiated</Form.Label>
                                <ThreeStateToggle 
                                  value={edit.token_initiated.values} 
                                  onChange={(val) => set_Edit({...edit, token_initiated: {...edit.token_initiated, values: val}})} 
                                  disabled={!canToggle('token_initiated')}
                                />

                                <AnimatePresence>
                                  {edit.token_initiated.values === 'yes' && (
                                    <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="mt-3">
                                      <Row className="g-2 mb-3">
                                        <Col md={6}>
                                          <Form.Label className="small fw-bold text-secondary text-uppercase mb-1">Token No.</Form.Label>
                                          <Form.Control 
                                            // Changed to text to allow alphanumeric codes like "D-001"
                                            type="text"
                                            className="shadow-none fw-bold"
                                            placeholder="000"
                                            value={edit.token_initiated.token_no || ''}
                                            disabled={user.role === "user" && edit.token_initiated.clicked > 0}
                                            // Error highlighting for Stage 6 validation
                                            isInvalid={currentStep === 6 && edit.token_initiated.values === 'yes' && !edit.token_initiated.token_no}
                                            onChange={(e) => {
                                              const val = e.target.value;
                                              // Regex allows A-Z, 0-9, slashes, hyphens, commas, dots, and spaces
                                              const regex = /^[A-Za-z0-9/\-,\s]*$/;
                                              
                                              if (regex.test(val)) {
                                                set_Edit({
                                                  ...edit, 
                                                  token_initiated: { 
                                                    ...edit.token_initiated, 
                                                    token_no: val 
                                                  }
                                                });
                                              }
                                            }}
                                          />
                                          <Form.Control.Feedback type="invalid">
                                            Token Number is required.
                                          </Form.Control.Feedback>
                                        </Col>
                                        <Col md={6}>
                                          <Form.Label className="small fw-bold text-secondary text-uppercase mb-1">Time Slot</Form.Label>
                                          <Select
                                            placeholder="Select Time..."
                                            options={timeOptions}
                                            styles={selectStyles}
                                            menuPortalTarget={document.body}
                                            isDisabled={user.role === "user" && edit.token_initiated.clicked > 0}
                                            value={edit.token_initiated.time ? { value: edit.token_initiated.time, label: TitleCase(edit.token_initiated.time) } : null}
                                            onChange={(selected) => set_Edit({...edit, token_initiated: {...edit.token_initiated, time: selected?.value || ""}})}
                                          />
                                        </Col>
                                      </Row>

                                      {/* --- NEW FILE UPLOAD FIELD --- */}
                                      <div className="mb-3 text-start">
  <Form.Label className="small fw-bold text-secondary mb-1">UPLOAD DOCUMENT (PDF, Max 5MB)</Form.Label>
  
  {/* 1. SHOW INPUT ONLY IF NO FILE EXISTS */}
  {!(edit?.token_initiated?.file || edit?.token_initiated?.fileData?.url) ? (
    <Form.Control 
      type="file" 
      accept="application/pdf"
      size="sm"
      onChange={(e) => {
        const file = e.target.files[0];
        if (file) {
          // Check if file is a PDF
          if (file.type !== 'application/pdf') {
            alert('Only PDF files are allowed.');
            e.target.value = null; // Reset the input
            return;
          }
          // Check if file is under 5 MB (5 * 1024 * 1024 bytes)
          if (file.size > 5 * 1024 * 1024) {
            alert('File size must be under 5 MB.');
            e.target.value = null; // Reset the input
            return;
          }
          
          // If valid, save to state
          set_Edit({
            ...edit,
            token_initiated: {
              ...edit.token_initiated,
              file: file // Saving the file to state
            }
          });
        }
      }}
    />
  ) : (
    /* 2. SHOW VIEW & REMOVE BUTTONS IF FILE EXISTS */
    <div className="d-flex justify-content-between align-items-center p-2 border rounded bg-light mt-1">
      <span className="small text-truncate text-muted fw-bold me-2">
        <i className="bi bi-file-earmark-pdf-fill text-danger me-2"></i>
        {edit.token_initiated.file ? edit.token_initiated.file.name : 'Token_Document.pdf'}
      </span>
      <div className="d-flex gap-2">
        <Button 
          variant="outline-primary" 
          size="sm" 
          className="fw-bold shadow-sm rounded-pill px-3"
          onClick={() => {
            // Generate a local URL for the selected file or use DB URL
            const url = edit.token_initiated.file ? URL.createObjectURL(edit.token_initiated.file) : edit.token_initiated.fileData?.url;
            if (url) window.open(url, '_blank');
          }}
        >
          <i className="bi bi-eye me-1"></i> VIEW
        </Button>
        <Button 
          variant="outline-danger" 
          size="sm" 
          className="fw-bold shadow-sm rounded-pill px-3"
          onClick={() => {
            // Completely remove the file from state to bring the input back
            set_Edit({
              ...edit,
              token_initiated: {
                ...edit.token_initiated,
                file: null,
                fileData: null // Clears DB data as well if applicable
              }
            });
          }}
        >
          <i className="bi bi-trash me-1"></i> REMOVE
        </Button>
      </div>
    </div>
  )}
</div>

                                      <div className="d-flex gap-2">
                                        <Button 
                                          className="flex-grow-1 fw-bold py-2 shadow-sm rounded-pill border-0"
                                          style={{backgroundColor: 'var(--brand-purple)', fontSize: '11px'}}
                                          onClick={() => handleMsg('TOKEN', { 
                                            app_no: app_No, 
                                            token: `D-${edit.token_initiated?.token_no}`,
                                            date: new Date().toLocaleDateString('en-GB'),
                                            time: edit.token_initiated?.time,
                                            office: typeof off === 'string' ? off.toUpperCase() : off?.value?.toUpperCase()
                                          })}
                                        >
                                          TOKEN INITIATED MESSAGE
                                        </Button>
                                        <Button 
                                          variant="outline-warning"
                                          className="fw-bold py-2 shadow-sm rounded-pill border-2"
                                          style={{fontSize: '11px', color: '#4a127e'}}
                                          onClick={() => handleMsg('RM', { 
                                            app_no: app_No, 
                                            token: `D-${edit.token_initiated?.token_no}`,
                                            date: new Date().toLocaleDateString('en-GB'),
                                            time: edit.token_initiated?.time,
                                            office: typeof off === 'string' ? off.toUpperCase() : off?.value?.toUpperCase()
                                          })}
                                        >
                                          REMINDER MESSAGE
                                        </Button>
                                      </div>
                                    </motion.div>
                                  )}
                                </AnimatePresence>
                              </Form.Group>
                            </div>
                          </Col>
                          )}

                        </Row>
                      </Card.Body>
                    </Card>
                  </motion.div>
                )}

                {/* STEP 7: Stamp & Finalization (stamp_paper, payment_details(new), document_registered, document_pending) */}
                {currentStep === 7 && (
                  <motion.div key="st7" initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>
                    <Card className="shadow-sm border-0 rounded-3">
                      <Card.Header className="bg-white border-0 pt-4 px-4">
                        <h5 className="fw-bold mb-0" style={{ color: "var(--brand-purple)" }}>
                          Registration Process
                        </h5>
                        <p className="text-muted small">Record stamp inventory and confirm final registration status.</p>
                      </Card.Header>
                      
                      <Card.Body className="px-4 pb-5">
                        <Row className="g-4">
                          
                          {/* --- STAMP PAPER SECTION --- */}
                          <Col xs={12}>
                            <div className="mb-5">
                              <h6 className="text-uppercase fw-bold mb-3 d-flex align-items-center justify-content-between" style={{ color: '#0dcaf0', fontSize: '0.8rem' }}>
                                <span className="me-2 flex-shrink-0">Stamp Paper</span>
                                <hr className="flex-grow-1 my-0 mx-2 opacity-10" />
                                <div className="p-2 rounded-pill border bg-light d-flex align-items-center px-3 shadow-sm flex-shrink-0">
                                  <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                    <Typography sx={{ fontSize: '11px', color: hasStampPaper === 'no' ? '#e7ac2d' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>No</Typography>
                                    <AntSwitch
                                      checked={hasStampPaper === 'yes'}
                                      onChange={(e) => {
                                        const next = e.target.checked ? 'yes' : 'no';
                                        setHasStampPaper(next);
                                        if (next === 'no') {
                                          set_Stamp_Paper([{ value: "", number: "" }]);
                                        }
                                      }}
                                    />
                                    <Typography sx={{ fontSize: '11px', color: hasStampPaper === 'yes' ? '#8a2be2' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>Yes</Typography>
                                  </Stack>
                                </div>
                              </h6>

                              {hasStampPaper === 'yes' && (
                                <>
                                  {stamp_Paper.map((stamp, index) => (
                                    <div key={index} className="mb-3 p-3 border-start border-4 border-info rounded-end bg-white shadow-sm">
                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                        <span className="fw-bold small text-dark">Stamp #{index + 1}</span>
                                        {stamp_Paper.length > 1 && (
                                          <Button variant="link" className="text-danger p-0 text-decoration-none small" onClick={() => handleRemovestamp_Paper(index)}>
                                            <MdClose /> Remove
                                          </Button>
                                        )}
                                      </div>
                                      <Row className="g-3">
                                        <Col md={4}>
                                          <Form.Label className="small fw-bold text-muted">VALUE (₹)</Form.Label>
                                          <Form.Select
                                            value={stamp.value || ""}
                                            onChange={(e) => handleChangestamp_Papervalue(index, e.target.value)}
                                          >
                                            <option value="">Select Value</option>
                                            <option value="100">100</option>
                                            <option value="500">500</option>
                                            <option value="1000">1,000</option>
                                            <option value="5000">5,000</option>
                                          </Form.Select>
                                        </Col>
                                        <Col md={8}>
                                          <Form.Label className="small fw-bold text-muted">STAMP NUMBER</Form.Label>
                                          <Form.Control
                                            placeholder="Ex: AA 123456"
                                            value={stamp.number || ""}
                                            isInvalid={currentStep === 7 && !stamp.number?.trim()}
                                            onChange={(e) => {
                                              const val = e.target.value;
                                              if (/^[A-Za-z0-9\s\-/]*$/.test(val)) {
                                                handleChangestamp_Papernumber(index, val);
                                              }
                                            }}
                                          />
                                        </Col>
                                      </Row>
                                    </div>
                                  ))}
                                  <Button variant="outline-info" className="rounded-pill px-3 fw-bold" size="sm" onClick={handleAddstamp_Paper}>
                                    <MdAdd /> Add Stamp
                                  </Button>
                                </>
                              )}
                            </div>
                          </Col>

                          {/* --- PAYMENT DETAILS --- */}
                          <Col xs={12} md={4}>                     
                            <Form.Group className="p-3 rounded-3 border bg-white h-100 shadow-sm">
                              <Form.Label className="small fw-bold text-muted text-uppercase mb-2">
                                Transaction No.
                              </Form.Label>
                              <Form.Control 
                                as="textarea"
                                rows={2}
                                name="payment_Info"
                                className="shadow-none border-0 bg-light"
                                placeholder="Transaction ID, Bank, or Payment Mode..."
                                value={individual.payment_Info || ''}
                                style={{ fontSize: '13px', resize: 'none' }}
                                // Red border if Step 7 is active but field is empty
                                isInvalid={currentStep === 7 && !individual.payment_Info}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  // Allows Letters, Numbers, Spaces, Hyphens, Slashes, and Commas
                                  const regex = /^[A-Za-z0-9\s\-_,/|]*$/;
                                  
                                  if (regex.test(val)) {
                                    set_Individual({
                                      ...individual,
                                      payment_Info: val
                                    });
                                  }
                                }}
                              />
                              <Form.Control.Feedback type="invalid">
                                Payment details (Numbers/Letters) are required for Stage 7.
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          {/* Online: Submitted Message then Final Registration | Offline: Final Registration then Pending */}
                          {status === 'online' && (
                            <Col xs={12} md={4}>
                              <div className="p-3 rounded-3 border h-100 bg-white">
                                <Form.Group>
                                  <Form.Label className="small fw-bold text-muted text-uppercase mb-3 d-block">Submitted Message</Form.Label>
                                  <Button 
                                    variant="success"
                                    size="sm" 
                                    className="w-100 fw-bold py-2 rounded-pill shadow-sm" 
                                    onClick={() => handleMsg('SUBMITTED')}
                                  >
                                    <i className="bi bi-send-check me-2"></i>SEND SUBMITTED MESSAGE
                                  </Button>
                                </Form.Group>
                              </div>
                            </Col>
                          )}

                          {/* --- DOCUMENT REGISTERED --- */}
                          <Col xs={12} md={4}>
                            <div className={`p-3 rounded-3 border h-100 ${edit.document_registered.values === 'yes' ? 'bg-light border-success-subtle' : 'bg-white'}`}>
                              <Form.Group>
                                <Form.Label className="small fw-bold text-muted text-uppercase mb-3 d-block">Final Registration</Form.Label>
                                <ThreeStateToggle 
                                  value={edit.document_registered.values} 
                                  onChange={(val) => set_Edit({...edit, document_registered: {...edit.document_registered, values: val}})} 
                                  disabled={!canToggle('document_registered')}
                                />

                                <AnimatePresence>
                                  {edit.document_registered.values === 'yes' && (
                                    <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} className="mt-3">
                                      <Form.Control 
                                        className="shadow-none fw-bold mb-2"
                                        // type="text" is essential here to allow the non-numeric characters
                                        type="text" 
                                        placeholder="Ex: REG-1234/A_26"
                                        value={edit.document_registered.document_no || ''} 
                                        // Keeps the red error border logic intact for Stage 7 completion
                                        isInvalid={edit.document_registered.values === 'yes' && !edit.document_registered.document_no}
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          // Regex allows: A-Z, a-z, 0-9, forward slash (/), hyphen (-), and underscore (_)
                                          const regex = /^[A-Za-z0-9/\-_ ]*$/;
                                          
                                          if (regex.test(val)) {
                                            set_Edit({
                                              ...edit, 
                                              document_registered: {
                                                ...edit.document_registered, 
                                                document_no: val 
                                              }
                                            });
                                          }
                                        }} 
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        Registration number is required (Letters, Numbers, / - _).
                                      </Form.Control.Feedback>
                                      <Button 
                                        variant="success"
                                        size="sm" 
                                        className="w-100 fw-bold py-2 rounded-pill shadow-sm" 
                                        onClick={() => handleMsg('REGISTERED', { 
                                          app_no: app_No, 
                                          document_number: `${edit.document_registered?.document_no}/${new Date().getFullYear()}`,
                                        })}
                                      >
                                        REGISTERED MESSAGE
                                      </Button>
                                    </motion.div>
                                  )}
                                </AnimatePresence>
                              </Form.Group>
                            </div>
                          </Col>

                          {/* --- DOCUMENT PENDING (Offline only) --- */}
                          {status !== 'online' && (
                          <Col xs={12} md={4}>
                            <div className={`p-3 rounded-3 border h-100 ${edit.document_pending.values === 'yes' ? 'bg-danger-subtle border-danger' : 'bg-white'}`}>
                              <Form.Group>
                                <Form.Label className="small fw-bold text-muted text-uppercase mb-3 d-block">Pending Status</Form.Label>
                                <div className="form-check form-switch custom-switch-large mb-2">
                                  <input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    role="switch"
                                    checked={edit.document_pending.values === 'yes'}
                                    disabled={user.role === "user" && edit.document_pending.clicked > 0}
                                    onChange={(e) => {
                                      const val = e.target.checked ? 'yes' : 'no';
                                      set_Edit({ ...edit, document_pending: { ...edit.document_pending, values: val } });
                                    }}
                                  />
                                  <label className={`form-check-label small fw-bold ms-2 ${edit.document_pending.values === 'yes' ? 'text-danger' : 'text-muted'}`}>
                                    {edit.document_pending.values === 'yes' ? "DOCUMENT PENDING" : "STATUS NORMAL"}
                                  </label>
                                </div>

                                <AnimatePresence>
                                  {edit.document_pending.values === 'yes' && (
                                    <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="mt-3 p-2 bg-white rounded-2 border border-danger shadow-sm">
                                      <Form.Label className="small text-danger fw-bold mb-1">PENDING DOC NO.</Form.Label>
                                      <Form.Control 
                                        size="sm"
                                        className="shadow-none border-0 bg-light fw-bold"
                                        // Changed to text to support / , - _ and Letters
                                        type="text" 
                                        placeholder="Ex: P-1234/2026" 
                                        value={edit.document_pending.document_no || ''} 
                                        // Highlights red if the Pending toggle is ON but no number is entered
                                        isInvalid={edit.document_pending.values === 'yes' && !edit.document_pending.document_no}
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          // Regex allows: A-Z, a-z, 0-9, forward slash (/), hyphen (-), and underscore (_)
                                          const regex = /^[A-Za-z0-9/\-_ ]*$/;
                                          
                                          if (regex.test(val)) {
                                            set_Edit({ 
                                              ...edit, 
                                              document_pending: { 
                                                ...edit.document_pending, 
                                                document_no: val 
                                              } 
                                            });
                                          }
                                        }} 
                                      />
                                      <Form.Control.Feedback type="invalid" style={{ fontSize: '10px' }}>
                                        Pending Doc No. is required (Letters, Numbers, / - _).
                                      </Form.Control.Feedback>
                                      <Button 
                                        variant="warning" // Changed to warning to differentiate from 'Registered' success
                                        size="sm" 
                                        className="w-100 mt-2 fw-bold py-2 rounded-pill shadow-sm border-0 text-white" 
                                        style={{ 
                                          backgroundColor: '#f39c12', // Professional amber/orange for pending status
                                          fontSize: '12px',
                                          letterSpacing: '0.5px'
                                        }}
                                        onClick={() =>handleMsg('REGISTERED', { 
                                          app_no: app_No, 
                                          // Uses the pending document number with current year
                                          document_number: `PENDING/${edit?.document_pending?.document_no}`,
                                        })}
                                      >
                                        PENDING DOCUMENT MESSAGE
                                      </Button>
                                    </motion.div>
                                  )}
                                </AnimatePresence>
                              </Form.Group>
                            </div>
                          </Col>
                          )}

                        </Row>
                      </Card.Body>
                    </Card>
                  </motion.div>
                )}

                {/* STEP 8: Collection Prep (document_collected, document_scanned) */}
                {currentStep === 8 && (
                  <motion.div key="st8" initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>
                    <Card className="shadow-sm border-0 rounded-3 overflow-hidden">
                      <Card.Header className="bg-white border-0 pt-4 px-4">
                        <h5 className="fw-bold mb-0" style={{ color: "var(--brand-purple)" }}>
                          <i className="bi bi-folder-check me-2"></i>Return Collection
                        </h5>
                        <p className="text-muted small">Finalize the physical handling and digital archival of the document.</p>
                      </Card.Header>
                      
                      <Card.Body className="px-4 pb-5">
                        <Row className="g-4 py-2">
                          
                          {/* --- DOCUMENT COLLECTED (Offline only) --- */}
                          {status !== 'online' && (
                          <Col xs={12} md={6}>
                            <div className={`p-4 rounded-3 border h-100 transition-smooth ${edit.document_collected.values === 'yes' ? 'bg-light border-primary-subtle' : 'bg-white'}`}>
                              <Form.Group>
                                <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                  1. Collection Status
                                </Form.Label>
                                <div className="mb-3">
                                  <ThreeStateToggle 
                                    value={edit.document_collected.values} 
                                    onChange={(val) => set_Edit({...edit, document_collected: {...edit.document_collected, values: val}})} 
                                    disabled={!canToggle('document_collected')}
                                  />
                                </div>

                                <AnimatePresence>
                                  {edit.document_collected.values === 'yes' && (
                                    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 10 }}>
                                      <Button 
                                        variant="primary"
                                        className="w-100 py-2 fw-bold shadow-sm rounded-pill mt-2" 
                                        style={{ backgroundColor: 'var(--brand-purple)', border: 'none', fontSize: '12px' }}
                                        onClick={() => handleMsg('COLLECTED', { 
                                          app_no: app_No, 
                                          document_number: `${edit.document_registered?.document_no}/${new Date().getFullYear()}`,
                                          office: typeof off === 'string' ? off.toUpperCase() : off?.label?.toUpperCase() || ''
                                        })}
                                      >
                                        <i className="bi bi-mailbox me-2"></i>COLLECTION MASSAGE
                                      </Button>
                                    </motion.div>
                                  )}
                                </AnimatePresence>
                              </Form.Group>
                            </div>
                          </Col>
                          )}

                          {/* --- DOCUMENT SCANNED / DOWNLOADED --- */}
                          <Col xs={12} md={status === 'online' ? 4 : 6}>
                            <div className={`p-4 rounded-3 border h-100 transition-smooth ${edit.document_scanned.values === 'yes' ? 'bg-light border-success-subtle' : 'bg-white'}`}>
                              <Form.Group>
                                <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">
                                  {status === 'online' ? '1. Downloaded Document' : '2. Scan Status'}
                                </Form.Label>
                                <div className="mb-3">
                                  <ThreeStateToggle 
                                    value={edit.document_scanned.values} 
                                    onChange={(val) => set_Edit({...edit, document_scanned: {...edit.document_scanned, values: val}})} 
                                    disabled={!canToggle('document_scanned')}
                                  />
                                </div>

                                <AnimatePresence>
                                  {edit.document_scanned.values === 'yes' && (
                                    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 10 }}>
                                      
                                      {/* --- NEW FILE UPLOAD FIELD --- */}
                                      <div className="mb-3 text-start">
  <Form.Label className="small fw-bold text-secondary mb-1">UPLOAD SCANNED DOCUMENT (PDF, Max 10MB)</Form.Label>
  
  {/* 1. SHOW INPUT ONLY IF NO FILE EXISTS */}
  {!(edit?.document_scanned?.file || edit?.document_scanned?.fileData?.url) ? (
    <Form.Control 
      type="file" 
      accept="application/pdf"
      size="sm"
      onChange={(e) => {
        const file = e.target.files[0];
        if (file) {
          // Check if file is a PDF
          if (file.type !== 'application/pdf') {
            alert('Only PDF files are allowed.');
            e.target.value = null; // Reset the input
            return;
          }
          // Check if file is under 10 MB (10 * 1024 * 1024 bytes)
          if (file.size > 10 * 1024 * 1024) {
            alert('File size must be under 10 MB.');
            e.target.value = null; // Reset the input
            return;
          }
          
          // If valid, save to state
          set_Edit({
            ...edit,
            document_scanned: {
              ...edit.document_scanned,
              file: file // Saving the file to state
            }
          });
        }
      }}
    />
  ) : (
    /* 2. SHOW VIEW & REMOVE BUTTONS IF FILE EXISTS */
    <div className="d-flex justify-content-between align-items-center p-2 border rounded bg-light mt-1">
      <span className="small text-truncate text-muted fw-bold me-2">
        <i className="bi bi-file-earmark-pdf-fill text-danger me-2"></i>
        {edit.document_scanned.file ? edit.document_scanned.file.name : 'Scanned_Document.pdf'}
      </span>
      <div className="d-flex gap-2">
        <Button 
          variant="outline-primary" 
          size="sm" 
          className="fw-bold shadow-sm rounded-pill px-3"
          onClick={() => {
            // Generate a local URL for the selected file or use DB URL
            const url = edit.document_scanned.file ? URL.createObjectURL(edit.document_scanned.file) : edit.document_scanned.fileData?.url;
            if (url) window.open(url, '_blank');
          }}
        >
          <i className="bi bi-eye me-1"></i> VIEW
        </Button>
        <Button 
          variant="outline-danger" 
          size="sm" 
          className="fw-bold shadow-sm rounded-pill px-3"
          onClick={() => {
            // Completely remove the file from state to bring the input back
            set_Edit({
              ...edit,
              document_scanned: {
                ...edit.document_scanned,
                file: null,
                fileData: null // Clears DB data as well if applicable
              }
            });
          }}
        >
          <i className="bi bi-trash me-1"></i> REMOVE
        </Button>
      </div>
    </div>
  )}
</div>

                                      <Button 
                                        variant="success"
                                        className="w-100 py-2 fw-bold shadow-sm rounded-pill mt-2" 
                                        style={{ fontSize: '12px' }}
                                        onClick={() => handleMsg('SCANNED', { 
                                          app_no: app_No, 
                                          document_number: `${edit.document_registered?.document_no}/${new Date().getFullYear()}`,
                                        })}
                                      >
                                        DOCUMENT SCANNED MESSAGE
                                      </Button>
                                    </motion.div>
                                  )}
                                </AnimatePresence>
                              </Form.Group>
                            </div>
                          </Col>

                        </Row>
                      </Card.Body>
                    </Card>
                  </motion.div>
                )}

                {/* STEP 9: Final (payment, document collected by) */}
                {currentStep === 9 && (
                  <motion.div key="st9" initial={{ opacity: 0, x: 10 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -10 }}>
                    <Card className="shadow-sm border-0 rounded-3 overflow-hidden">
                      <Card.Header className="bg-white border-0 pt-4 px-4">
                        <h5 className="fw-bold mb-0" style={{ color: "var(--brand-purple)" }}>
                          <i className="bi bi-hand-thumbs-up me-2"></i>Application Completed
                        </h5>
                        <p className="text-muted small">Verify payment completion and record the document recipient.</p>
                      </Card.Header>
                      
                      <Card.Body className="px-4 pb-5">
                        <Row className="g-4">
                          
                          {/* --- DOCUMENT PAYMENT COMPLETED --- */}
                          <Col xs={12} md={6}>
                            <div className={`p-4 rounded-3 border h-100 ${edit.payment.values === 'yes' ? 'bg-light border-success-subtle' : 'bg-white'}`}>
                              <Form.Group>
                                <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">1. Financial Settlement</Form.Label>
                                <div className="mb-3">
                                  <ThreeStateToggle 
                                    value={edit.payment.values} 
                                    onChange={(val) => set_Edit({...edit, payment: {...edit.payment, values: val}})} 
                                    disabled={!canToggle('payment')}
                                  />
                                </div>
                                <div className="d-flex align-items-center">
                                  <div 
                                    className="rounded-circle me-2" 
                                    style={{ 
                                      width: '10px', height: '10px', 
                                      backgroundColor: edit.payment.values === 'yes' ? '#28a745' : '#dc3545' 
                                    }}
                                  ></div>
                                  <span className="d-inline-flex overflow-hidden align-items-center" style={{ height: '18px' }}>
    <AnimatePresence mode="wait">
        <motion.span
            key={edit.payment.values || 'pending'} /* Triggers the animation on status change */
            initial={{ y: 15, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -15, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="fw-bold text-uppercase" 
            style={{ 
                color: edit.payment.values === 'yes' ? '#28a745' : '#dc3545', 
                fontSize: '12px', 
                letterSpacing: '0.5px' 
            }}
        >
            {edit.payment.values === 'yes' ? 'Payment Received' : edit.payment.values === 'no' ? 'Unpaid / Pending' : 'Awaiting Update'}
        </motion.span>
    </AnimatePresence>
</span>
                                </div>
                              </Form.Group>
                            </div>
                          </Col>

                          {/* --- COLLECTION HANDOVER LOGIC --- */}
                          <Col xs={12} md={6}>
                            <div className="p-4 rounded-3 border bg-white h-100">
                              <Form.Group>
                                <Form.Label className="small fw-bold text-muted text-uppercase d-block mb-3">2. Document Handover</Form.Label>
                                <div className="mb-2">
                                  <ThreeStateToggle 
                                    value={edit.other.values} 
                                    onChange={(val) => set_Edit({...edit, other: {...edit.other, values: val}})} 
                                    disabled={!canToggle('other')}
                                  />
                                </div>
                                <p className="text-muted mb-0" style={{ fontSize: '11px', lineHeight: '1.4' }}>
                                  <i className="bi bi-info-circle me-1"></i>
                                  Select <strong>'No'</strong> if a any other represented person by the buyer to collected the document instead of the Buyer.
                                </p>
                              </Form.Group>
                            </div>
                          </Col>

                          {/* --- OTHER COLLECTOR DETAILS --- */}
                          <AnimatePresence>
                            {edit.other.values === 'yes' && (
                              <motion.div 
                                initial={{ opacity: 0, y: -20 }} 
                                animate={{ opacity: 1, y: 0 }} 
                                exit={{ opacity: 0, y: -20 }}
                                className="col-12"
                              >
                                <div className="p-4 rounded-3 border-start border-4 border-primary bg-light shadow-sm">
                                  <h6 className="small fw-bold text-primary text-uppercase mb-4">Recipient Information</h6>
                                  <Row className="g-3">
                                    <Form.Group as={Col} md={4}>
                                      <Form.Label className="small fw-bold text-muted">NAME {edit.other?.cusDetail?.cid && <span className="badge bg-primary ms-1">{edit.other.cusDetail.cid}</span>}</Form.Label>
                                      <CreatableSelect
                                        isClearable
                                        value={edit.other?.cusDetail?.name ? { value: edit.other.cusDetail, label: edit.other.cusDetail.name.toUpperCase() } : null}
                                        options={options || []}
                                        styles={selectStyles} // Your custom styles for Portal
                                        menuPortalTarget={document.body}
                                        placeholder="Search Recipient..."
                                        onChange={(val) => set_Edit({...edit, other: {...edit.other, cusDetail: val ? val.value : null}})}
                                      />
                                    </Form.Group>
                                    <Form.Group as={Col} md={4}>
                                      <Form.Label className="small fw-bold text-muted">ADDRESS</Form.Label>
                                      <Form.Control readOnly value={TitleCase(edit.other?.cusDetail?.address)} className="bg-white border-0 shadow-none" />
                                    </Form.Group>
                                    <Form.Group as={Col} md={2}>
                                      <Form.Label className="small fw-bold text-muted">DISTRICT</Form.Label>
                                      <Form.Control readOnly value={TitleCase(edit.other?.cusDetail?.city)} className="bg-white border-0 shadow-none" />
                                    </Form.Group>
                                    <Form.Group as={Col} md={2}>
                                      <Form.Label className="small fw-bold text-muted">MOBILE</Form.Label>
                                      <Form.Control readOnly value={edit.other?.cusDetail?.mobile || ''} className="bg-white border-0 shadow-none" />
                                    </Form.Group>
                                  </Row>
                                </div>
                              </motion.div>
                            )}
                          </AnimatePresence>

                          {/* --- FINAL ACTION --- */}
                          <Col xs={12} className="pt-4 border-top">
  {/* --- NEW TEXT FIELDS --- */}
  <Row className="g-4 mb-4 text-start">
    <Col md={6}>
      <Form.Group>
        <Form.Label className="small fw-bold text-muted text-uppercase mb-2">
          Remarks
        </Form.Label>
        <Form.Control 
          as="textarea" 
          rows={5} 
          name="remarks"
          className="shadow-none border-secondary-subtle bg-light"
          placeholder="Enter any final remarks..."
          value={individual.remarks || ''} 
          onChange={handleIndividualChange}
        />
      </Form.Group>
    </Col>
    
    <Col md={6}>
      <Form.Group>
        <Form.Label className="small fw-bold text-muted text-uppercase mb-2">
          Internal Notes
        </Form.Label>
        <Form.Control 
          as="textarea" 
          rows={5} 
          name="internal_notes"
          className="shadow-none border-secondary-subtle bg-white"
          placeholder="Enter private internal notes here..."
          value={individual.internal_notes || ''} 
          onChange={handleIndividualChange}
        />
      </Form.Group>
    </Col>
  </Row>

  {/* --- FINAL ACTION BUTTON --- */}
  <div className="text-center">
    <div className="mb-3 small text-muted px-md-5">
      Once you send the final message, the application process is officially marked as complete in the system records.
    </div>
    <Button 
      size="lg"
      className="px-5 py-3 fw-bold shadow rounded-pill border-0"
      style={{ backgroundColor: 'var(--brand-purple)', transition: 'transform 0.2s' }}
      onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
      onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
      onClick={() => handleMsg('THANK', { 
        app_no: app_No, 
        document_number: `${edit.document_registered?.document_no}/${new Date().getFullYear()}` 
      })}
    >
      <i className="bi bi-stars me-2"></i>SEND THANK YOU MESSAGE
    </Button>
  </div>
</Col>

                        </Row>
                      </Card.Body>
                    </Card>
                  </motion.div>
                )}

              </AnimatePresence>

              {/* STEPPER NAVIGATION */}
              <div className="d-flex justify-content-between align-items-center mt-5 mb-5 pt-4 border-top">
  
  {/* --- BACK BUTTON --- */}
  <Button 
    type="button" // Force it to NOT submit
    variant="outline-secondary" 
    onClick={() => { 
          if (!validateCurrentStep(currentStep)) return; // Validates current step before moving forward
          setCurrentStep(p => getAdjacentStep(p, -1));
        }} // Removed validation here to allow free backward navigation
    disabled={currentStep === 1} 
    className="d-flex align-items-center gap-2 px-4 py-2 fw-bold rounded-pill transition-smooth"
  >
    <MdChevronLeft size={20} /> Back
  </Button>

  {/* --- NEXT & SUBMIT BUTTONS --- */}
  <div className="d-flex gap-3">
    
    {/* Renders ONLY on Steps 1 to 8 */}
    {currentStep < 9 && (
      <Button 
        type="button" // CRITICAL: Prevents accidental submission
        style={{ backgroundColor: 'var(--brand-purple, #4a127e)', border: 'none', color: 'white' }} 
        onClick={() => { 
          if (!validateCurrentStep(currentStep)) return; // Validates current step before moving forward
          setCurrentStep(p => getAdjacentStep(p, 1));
        }}
        className="d-flex align-items-center gap-2 px-4 py-2 fw-bold shadow-sm rounded-pill transition-smooth"
      >
        Next Step <MdChevronRight size={20} />
      </Button>
    )}

    {/* ALWAYS renders, allowing early or final submission */}
    <Button 
      type="submit" // Only button allowed to submit
      variant="success" 
      disabled={bt} 
      className="d-flex align-items-center justify-content-center gap-2 px-5 py-2 fw-bold shadow rounded-pill transition-smooth"
    >
      {bt ? (
        <>
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Submitting...
        </>
      ) : (
        'Complete Registration'
      )}
    </Button>
    
  </div>
</div>

            </Form>

          </Container>
        </main>
      </div>
      <Footer />
      
      {/* Modals & Popups */}
      <AnimatePresence>
        {add && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="modal-overlay-wrapper">
            <AddClient setAdd={setAdd} showToast={showToast} get_customer={fetchClients} />
          </motion.div>
        )}
        {msg && (
          <motion.div initial={{ y: 50 }} animate={{ y: 0 }} exit={{ y: 50 }} style={{ position: 'fixed', bottom: '40px', left: 0, right: 0, zIndex: 3000, display: 'flex', justifyContent: 'center' }}>
            <CopyMsg set_msg={set_msg} content={activeMsgText} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Registration;